export const parentCategories = {
  // Packages: ["Packages", "WWII Package", "Vietnam Package", "Modern Warfare Package", "Extreme Package"],

  Category: [
    "Assault Rifles",
    "Battle Rifles",
    "Submachine Guns",
    "Machine Guns",
    "Shotguns",
    "Pistols",
    "Sniper Rifles",
    "Carbines",
    "Grenade Launchers",
  ],

  Historical: [
    "WWII",
    "Vietnam",
    "Cold War",
    "WWI",
    "Korean War",
  ],

  Origin: [
    "United States",
    "Russia",
    "Germany",
    "Great Britain",
    "Belgium",
    "Israel",
    "Switzerland",
    "Austria",
    "Italy",
    "France",
    "Czech Republic",
    "Poland",
    "Hungary",
    "Singapore",
    "South Korea",
    "Croatia",
    "China",
    "Sweden",
    "Finland",
    "Denmark",
    "Australia",
    "Japan",
  ],

  Design: [
    "Bullpup",
    "NATO Standard",
    "Eastern Bloc",
    "Modern Tactical",
    "Suppressed",
    "Belt-Fed",
  ],

  Appeal: [
    "Top Rated",
    "Movie Famous",
    "Collector's Item",
    "Battle Tested",
    "Video Game Famous",
  ],

  Skill: ["Beginner Friendly", "Advanced"]
};

export const category_descriptions = {
  // "Packages": "Curated firearm experiences bundled together for the ultimate shooting adventure.",
  "WWII Package": "Experience the weapons that shaped World War II from both Allied and Axis forces.",
  "Vietnam Package": "Fire the iconic weapons of the Vietnam War era.",
  "Modern Warfare Package": "Today's cutting-edge military hardware from around the world.",
  "Extreme Package": "Our most powerful and impressive firearms for thrill seekers.",
  "Assault Rifles": "Select-fire rifles designed for modern infantry combat.",
  "Battle Rifles": "Full-powered rifles chambered in full-size cartridges for maximum stopping power.",
  "Submachine Guns": "Compact automatic weapons ideal for close-quarters combat.",
  "Machine Guns": "Belt-fed and magazine-fed automatic weapons for sustained firepower.",
  "Shotguns": "Devastating close-range firepower with various ammunition options.",
  "Pistols": "Sidearms ranging from historic to modern tactical designs.",
  "Sniper Rifles": "Precision long-range rifles for marksman enthusiasts.",
  "Carbines": "Shortened rifles offering maneuverability without sacrificing firepower.",
  "Grenade Launchers": "Launch projectiles for explosive fun on the range.",
  "WWII": "Authentic firearms from the Second World War.",
  "Vietnam": "Weapons that saw action in the jungles of Southeast Asia.",
  "Cold War": "Arms from the era of superpower standoff.",
  "WWI": "Historic weapons from the Great War.",
  "Korean War": "Firearms from the Forgotten War.",
  "United States": "American-designed and manufactured firearms.",
  "Russia": "Soviet and Russian military hardware.",
  "Germany": "Precision German engineering.",
  "Great Britain": "British military firearms.",
  "Belgium": "FN Herstal and other Belgian designs.",
  "Israel": "Battle-tested Israeli Defense Force weapons.",
  "Switzerland": "Swiss precision manufacturing.",
  "Austria": "Austrian firearms innovation.",
  "Italy": "Italian craftsmanship in firearms.",
  "France": "French military weapons.",
  "Czech Republic": "Czech firearms engineering.",
  "Poland": "Polish military designs.",
  "Hungary": "Hungarian variants and designs.",
  "Singapore": "Singapore's military innovations.",
  "South Korea": "South Korean defense industry firearms.",
  "Croatia": "Croatian military weapons.",
  "China": "Chinese military hardware.",
  "Sweden": "Swedish precision engineering.",
  "Finland": "Finnish military firearms.",
  "Denmark": "Danish weapon designs.",
  "Australia": "Australian military hardware.",
  "Japan": "Japanese military firearms.",
  "Bullpup": "Compact designs with the action behind the trigger for shorter overall length.",
  "NATO Standard": "Weapons chambered in NATO-standard calibers.",
  "Eastern Bloc": "Soviet-influenced designs from Warsaw Pact nations.",
  "Modern Tactical": "Contemporary military and law enforcement firearms.",
  "Suppressed": "Firearms equipped with suppressors for reduced sound.",
  "Belt-Fed": "Machine guns fed by ammunition belts for sustained fire.",
  "Top Rated": "Guest favorites with the highest ratings.",
  "Movie Famous": "Iconic weapons from Hollywood blockbusters.",
  "Collector's Item": "Rare and historically significant firearms.",
  "Battle Tested": "Proven in actual military conflicts.",
  "Video Game Famous": "Popular weapons featured in video games.",
  "Beginner Friendly": "Easy to handle firearms perfect for first-time shooters.",
  "Advanced": "Challenging weapons for experienced shooters."
};

export interface Gun {
  id: string;
  title: string;
  price: string;
  description: string;
  images: string[];
  category: string;
  origin: string;
  caliber?: string;
  likes: number;
}

export const items: Gun[] = [
  // ============================================
  // ASSAULT RIFLES
  // ============================================
  {
    id: "m4_carbine",
    title: "M4 Carbine",
    price: "60",
    description: "The M4 carbine is the choice weapon for the US military and numerous nations around the world. This shorter, lighter variant of the M16A2 rifle has been the standard-issue firearm for most units in the U.S. military since 2005. Its compact size makes it ideal for close-quarters combat while maintaining accuracy at medium ranges.",
    images: [
      "/img/vegas-guns/M4-Assault-Rifle-.jpg",
      "/img/vegas-guns/M4-Assault-Rifle- (1).jpg",
      "/img/vegas-guns/M4-Assault-Rifle- (2).jpg"
    ],
    category: "Assault Rifles, United States, NATO Standard, Modern Tactical, Battle Tested, Top Rated, Video Game Famous",
    origin: "United States",
    caliber: "5.56x45mm NATO",
    likes: 245
  },
  {
    id: "ak47",
    title: "AK-47",
    price: "60",
    description: "Shoot the infamous AK-47 Assault Rifle! Developed by Mikhail Kalashnikov in 1947, this legendary rifle is renowned worldwide for its reliability, durability, and ease of use. The AK-47 has seen action in virtually every conflict since World War II and remains one of the most recognizable firearms ever made.",
    images: [
      "/img/vegas-guns/AK-47-Assault-Rifle-.jpg",
      "/img/vegas-guns/AK-47-Assault-Rifle- (1).jpg",
      "/img/vegas-guns/AK-47-Assault-Rifle- (2).jpg"
    ],
    category: "Assault Rifles, Russia, Eastern Bloc, Cold War, Battle Tested, Movie Famous, Video Game Famous, Top Rated",
    origin: "Russia",
    caliber: "7.62x39mm",
    likes: 312
  },
  {
    id: "ak74",
    title: "AK-74",
    price: "60",
    description: "From Afghanistan to Ukraine, the AK-74 assault rifle has been a staple of Soviet and Russian military forces. Introduced in 1974 as a replacement for the AK-47, it fires the smaller 5.45x39mm cartridge, offering reduced recoil and improved accuracy while maintaining the legendary Kalashnikov reliability.",
    images: [
      "/img/vegas-guns/AK74.jpg",
      "/img/vegas-guns/AK74 (1).jpg",
      "/img/vegas-guns/AK74 (2).jpg"
    ],
    category: "Assault Rifles, Russia, Eastern Bloc, Cold War, Battle Tested",
    origin: "Russia",
    caliber: "5.45x39mm",
    likes: 89
  },
  {
    id: "fn_scar_h",
    title: "FN SCAR-H",
    price: "60",
    description: "Take on the FN SCAR-H Assault Rifle with its rotating bolt system! Developed by FN Herstal for U.S. Special Operations Command (SOCOM), the SCAR-H (Heavy) is chambered in 7.62x51mm NATO and delivers exceptional accuracy and stopping power. Used by elite military units worldwide.",
    images: [
      "/img/vegas-guns/FN-SCAR-H-Assault-Rifle.jpg",
      "/img/vegas-guns/FN-SCAR-H-Assault-Rifle (1).jpg",
      "/img/vegas-guns/FN-SCAR-H-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, Belgium, NATO Standard, Modern Tactical, Battle Tested, Video Game Famous",
    origin: "Belgium",
    caliber: "7.62x51mm NATO",
    likes: 156
  },
  {
    id: "fn_scar_l",
    title: "FN SCAR-L",
    price: "60",
    description: "Blast away with the FN SCAR-L Assault Rifle! The Light variant of the SCAR platform is chambered in 5.56x45mm NATO and offers the same modular design and reliability as its heavier sibling. Favored by special operations forces for its adaptability and performance.",
    images: [
      "/img/vegas-guns/FN-SCAR-L-Assault-Rifle.jpg",
      "/img/vegas-guns/FN-SCAR-L-Assault-Rifle (1).jpg",
      "/img/vegas-guns/FN-SCAR-L-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, Belgium, NATO Standard, Modern Tactical, Battle Tested",
    origin: "Belgium",
    caliber: "5.56x45mm NATO",
    likes: 134
  },
  {
    id: "hk416",
    title: "HK 416",
    price: "60",
    description: "The HK 416 is an assault rifle designed and manufactured by Heckler & Koch. Using a short-stroke gas piston system derived from the HK G36, this rifle offers improved reliability over the standard M4/M16 platform. Famously used by SEAL Team Six in Operation Neptune Spear.",
    images: [
      "/img/vegas-guns/HK-416-Assault-Rifle.jpg",
      "/img/vegas-guns/HK-416-Assault-Rifle (1).jpg",
      "/img/vegas-guns/HK-416-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, Germany, NATO Standard, Modern Tactical, Battle Tested, Movie Famous",
    origin: "Germany",
    caliber: "5.56x45mm NATO",
    likes: 201
  },
  {
    id: "hk_g3",
    title: "HK G3",
    price: "60",
    description: "The HK G3 battle rifle was used by the West German military and military units in Mexico, Central America, South America, and Africa. This roller-delayed blowback operated rifle chambered in 7.62x51mm NATO became one of the most widely used battle rifles in the world.",
    images: [
      "/img/vegas-guns/HK-G3-Main-Battle-Rifle.jpg",
      "/img/vegas-guns/HK-G3-Main-Battle-Rifle (1).jpg",
      "/img/vegas-guns/HK-G3-Main-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, Germany, NATO Standard, Cold War, Battle Tested",
    origin: "Germany",
    caliber: "7.62x51mm NATO",
    likes: 78
  },
  {
    id: "hk_g36",
    title: "HK G36",
    price: "60",
    description: "Enjoy the enhanced mobility of the HK G36 Assault Rifle! This German assault rifle was designed in the early 1990s as a replacement for the G3. Its lightweight polymer construction and integrated optics make it a favorite among military and law enforcement units.",
    images: [
      "/img/vegas-guns/HK-G36-K-Assault-Rifle-e1530225055939.jpg",
      "/img/vegas-guns/HK-G36-K-Assault-Rifle-e1530225055939 (1).jpg",
      "/img/vegas-guns/HK-G36-K-Assault-Rifle-e1530225055939 (2).jpg"
    ],
    category: "Assault Rifles, Germany, NATO Standard, Modern Tactical, Battle Tested",
    origin: "Germany",
    caliber: "5.56x45mm NATO",
    likes: 92
  },
  {
    id: "m16a1",
    title: "M16A1",
    price: "60",
    description: "Born during the Vietnam War, the M16A1 Assault Rifle is an iconic piece of American military history. The improved version of the original M16, featuring a forward assist and chrome-lined barrel, became the standard U.S. military rifle and saw extensive combat in Southeast Asia.",
    images: [
      "/img/vegas-guns/M16A1-Assault-Rifle.jpg",
      "/img/vegas-guns/M16A1-Assault-Rifle (1).jpg",
      "/img/vegas-guns/M16A1-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, United States, NATO Standard, Vietnam, Battle Tested, Movie Famous, Video Game Famous",
    origin: "United States",
    caliber: "5.56x45mm NATO",
    likes: 167
  },
  {
    id: "m16a2",
    title: "M16A2",
    price: "60",
    description: "The upgraded M16A2 Assault Rifle served from Afghanistan to operations worldwide. Introduced in the 1980s, this improved variant features a heavier barrel, adjustable rear sight, and three-round burst capability instead of full-auto, improving accuracy and ammunition conservation.",
    images: [
      "/img/vegas-guns/M16A2-Assault-Rifle.jpg",
      "/img/vegas-guns/M16A2-Assault-Rifle (1).jpg",
      "/img/vegas-guns/M16A2-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, United States, NATO Standard, Battle Tested",
    origin: "United States",
    caliber: "5.56x45mm NATO",
    likes: 84
  },
  {
    id: "m16a4_ris",
    title: "M16A4 RIS",
    price: "60",
    description: "The M16A4 RIS (Rail Interface System) represents the latest evolution of the venerable M16 platform. Featuring a flat-top receiver with Picatinny rails for optics and accessories, this rifle served as the standard issue for U.S. Marines until being replaced by the M4.",
    images: [
      "/img/vegas-guns/M16A4-RIS-Assault-Rifle.jpg",
      "/img/vegas-guns/M16A4-RIS-Assault-Rifle (1).jpg",
      "/img/vegas-guns/M16A4-RIS-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, United States, NATO Standard, Modern Tactical, Battle Tested",
    origin: "United States",
    caliber: "5.56x45mm NATO",
    likes: 73
  },
  {
    id: "m14_ebr",
    title: "M14 EBR",
    price: "60",
    description: "The M14 Enhanced Battle Rifle combines the proven M14 action with a modern chassis system. Used by U.S. military personnel during Vietnam and revived for Iraq/Afghanistan conflicts, the EBR configuration adds adjustable stock, rails, and improved ergonomics for designated marksman roles.",
    images: [
      "/img/vegas-guns/M14-EBR-Main-Battle-Rifle.jpg",
      "/img/vegas-guns/M14-EBR-Main-Battle-Rifle (1).jpg",
      "/img/vegas-guns/M14-EBR-Main-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, United States, NATO Standard, Vietnam, Battle Tested, Video Game Famous",
    origin: "United States",
    caliber: "7.62x51mm NATO",
    likes: 145
  },
  {
    id: "m14",
    title: "M14",
    price: "60",
    description: "Fire the M14 main battle rifle! This classic American rifle served as the standard U.S. military rifle from 1959 to 1970. Chambered in 7.62x51mm NATO, it offers excellent accuracy and stopping power, making it a favorite among marksmen to this day.",
    images: [
      "/img/vegas-guns/M14-Main-Battle-Rifle.jpg",
      "/img/vegas-guns/M14-Main-Battle-Rifle (1).jpg",
      "/img/vegas-guns/M14-Main-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, United States, NATO Standard, Vietnam, Battle Tested, Collector's Item",
    origin: "United States",
    caliber: "7.62x51mm NATO",
    likes: 112
  },
  {
    id: "sig_552",
    title: "SIG 552",
    price: "60",
    description: "Try out the SIG 552 Assault Rifle! This compact Swiss assault rifle is the carbine version of the SIG 550 family. Known for Swiss precision manufacturing, the 552 offers exceptional accuracy in a compact package favored by special operations and law enforcement units.",
    images: [
      "/img/vegas-guns/SIG-552-Assault-Rifle-e1530224303770.jpg",
      "/img/vegas-guns/SIG-552-Assault-Rifle-e1530224303770 (1).jpg",
      "/img/vegas-guns/SIG-552-Assault-Rifle-e1530224303770 (2).jpg"
    ],
    category: "Assault Rifles, Switzerland, NATO Standard, Modern Tactical",
    origin: "Switzerland",
    caliber: "5.56x45mm NATO",
    likes: 67
  },
  {
    id: "sig_mcx",
    title: "SIG MCX",
    price: "60",
    description: "The SIG MCX is the short-barreled rifle version of the MCX VIRTUS platform. This modular weapon system features a short-stroke gas piston and can be quickly configured for different barrel lengths and calibers, making it highly adaptable for various mission requirements.",
    images: [
      "/img/vegas-guns/SIG-MCX-Assault-Rifle.jpg",
      "/img/vegas-guns/SIG-MCX-Assault-Rifle (1).jpg",
      "/img/vegas-guns/SIG-MCX-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, Switzerland, NATO Standard, Modern Tactical",
    origin: "Switzerland",
    caliber: "5.56x45mm NATO",
    likes: 89
  },
  {
    id: "steyr_aug",
    title: "Steyr AUG",
    price: "60",
    description: "The advanced alloy Steyr AUG Assault Rifle will blow your socks off! This Austrian bullpup rifle revolutionized military firearms when introduced in 1977. Its futuristic design, integrated optics, and ambidextrous controls make it a favorite in movies and military units worldwide.",
    images: [
      "/img/vegas-guns/Steyr-AUG-Assault-Rifle1.jpg",
      "/img/vegas-guns/Steyr-AUG-Assault-Rifle1 (1).jpg",
      "/img/vegas-guns/Steyr-AUG-Assault-Rifle1 (2).jpg"
    ],
    category: "Assault Rifles, Austria, Bullpup, NATO Standard, Battle Tested, Movie Famous, Video Game Famous",
    origin: "Austria",
    caliber: "5.56x45mm NATO",
    likes: 178
  },
  {
    id: "tavor",
    title: "Tavor",
    price: "60",
    description: "Blast rounds with the Israeli Defense Force's Tavor Assault Rifle! This bullpup rifle is the standard issue weapon for the IDF infantry. Its compact design makes it ideal for urban combat and vehicle operations while maintaining full rifle performance.",
    images: [
      "/img/vegas-guns/Tavor-Assault-Rifle.jpg",
      "/img/vegas-guns/Tavor-Assault-Rifle (1).jpg",
      "/img/vegas-guns/Tavor-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, Israel, Bullpup, NATO Standard, Modern Tactical, Battle Tested",
    origin: "Israel",
    caliber: "5.56x45mm NATO",
    likes: 134
  },
  {
    id: "galil",
    title: "Galil",
    price: "60",
    description: "The Israeli Defense Force's Galil assault rifle combines AK-47 reliability with NATO compatibility. Developed after the Six-Day War, the Galil incorporates lessons learned from captured Kalashnikov rifles while chambering the 5.56mm NATO round.",
    images: [
      "/img/vegas-guns/Galil-Assault-Rifle-e1530224534744.jpg",
      "/img/vegas-guns/Galil-Assault-Rifle-e1530224534744 (1).jpg",
      "/img/vegas-guns/Galil-Assault-Rifle-e1530224534744 (2).jpg"
    ],
    category: "Assault Rifles, Israel, NATO Standard, Cold War, Battle Tested",
    origin: "Israel",
    caliber: "5.56x45mm NATO",
    likes: 98
  },
  {
    id: "fn_f2000",
    title: "FN F2000",
    price: "60",
    description: "Check out this bullpup FN F2000! This futuristic Belgian assault rifle features a unique forward ejection system that ejects spent casings through a tube above the barrel, making it truly ambidextrous. Its space-age design has made it popular in science fiction media.",
    images: [
      "/img/vegas-guns/FN-F2000.jpg",
      "/img/vegas-guns/FN-F2000 (1).jpg",
      "/img/vegas-guns/FN-F2000 (2).jpg"
    ],
    category: "Assault Rifles, Belgium, Bullpup, NATO Standard, Modern Tactical, Movie Famous, Video Game Famous",
    origin: "Belgium",
    caliber: "5.56x45mm NATO",
    likes: 87
  },
  {
    id: "vhs_hellion",
    title: "VHS / Hellion",
    price: "60",
    description: "The VHS Hellion Bullpup Assault Rifle is issued to police and special operations forces around the world. This Croatian bullpup design offers excellent ergonomics and reliability in a compact package.",
    images: [
      "/img/vegas-guns/VHS-rifle.jpg",
      "/img/vegas-guns/VHS-rifle (1).jpg",
      "/img/vegas-guns/VHS-rifle (2).jpg"
    ],
    category: "Assault Rifles, Croatia, Bullpup, NATO Standard, Modern Tactical",
    origin: "Croatia",
    caliber: "5.56x45mm NATO",
    likes: 45
  },
  {
    id: "hk_g3_hammer",
    title: "HK G3 Hammer (HK51)",
    price: "60",
    description: "The HK51, also known as the G3 'Hammer', is not a gun that was ever actually produced by Heckler & Koch. This ultra-compact variant of the G3 was created by aftermarket manufacturers, combining the powerful 7.62mm NATO cartridge with an extremely short barrel for devastating close-range firepower.",
    images: [
      "/img/vegas-guns/G3-Hammer.jpeg",
      "/img/vegas-guns/G3-Hammer (1).jpeg",
      "/img/vegas-guns/G3-Hammer (2).jpeg"
    ],
    category: "Assault Rifles, Germany, NATO Standard, Advanced, Movie Famous",
    origin: "Germany",
    caliber: "7.62x51mm NATO",
    likes: 156
  },
  {
    id: "hk_g33",
    title: "HK G33",
    price: "60",
    description: "The HK G33 is the compact carbine version of the HK33 assault rifle. Using the same roller-delayed blowback system as the G3, but chambered in 5.56mm NATO, it offers reduced weight and recoil while maintaining H&K's renowned reliability.",
    images: [
      "/img/vegas-guns/HK-G33-Assault-Rifle.jpg",
      "/img/vegas-guns/HK-G33-Assault-Rifle (1).jpg",
      "/img/vegas-guns/HK-G33-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, Germany, NATO Standard, Cold War",
    origin: "Germany",
    caliber: "5.56x45mm NATO",
    likes: 54
  },
  {
    id: "beretta_arx100",
    title: "Beretta ARX-100",
    price: "60",
    description: "The reliability and functionality of the Beretta ARX-100 Assault Rifle is untouched! This modular Italian rifle features ambidextrous controls, a quick-change barrel system, and can be configured for left or right-hand ejection in seconds.",
    images: [
      "/img/vegas-guns/Beretta-ARX-100-e1530224336322.jpg",
      "/img/vegas-guns/Beretta-ARX-100-e1530224336322 (1).jpg",
      "/img/vegas-guns/Beretta-ARX-100-e1530224336322 (2).jpg"
    ],
    category: "Assault Rifles, Italy, NATO Standard, Modern Tactical",
    origin: "Italy",
    caliber: "5.56x45mm NATO",
    likes: 62
  },
  {
    id: "beretta_ar70",
    title: "Beretta AR-70",
    price: "60",
    description: "Try this self-loading assault rifle from Beretta! The AR-70 was Italy's standard military rifle, featuring a rotating bolt and gas-operated action. Known for its reliability and accuracy.",
    images: [
      "/img/vegas-guns/Beretta-AR-70-Assault-Rifle.jpg",
      "/img/vegas-guns/Beretta-AR-70-Assault-Rifle (1).jpg",
      "/img/vegas-guns/Beretta-AR-70-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, Italy, NATO Standard, Cold War, Battle Tested",
    origin: "Italy",
    caliber: "5.56x45mm NATO",
    likes: 43
  },
  {
    id: "mini_beryl",
    title: "Mini-Beryl",
    price: "60",
    description: "Check out this 3-round burst monster! The Mini-Beryl is Poland's compact assault rifle based on the AK platform. Chambered in 5.56mm NATO and featuring a folding stock, it's designed for vehicle crews and special operations forces.",
    images: [
      "/img/vegas-guns/Mini-Beryl-Assault-Rifle-e1530224456188.jpg",
      "/img/vegas-guns/Mini-Beryl-Assault-Rifle-e1530224456188 (1).jpg",
      "/img/vegas-guns/Mini-Beryl-Assault-Rifle-e1530224456188 (2).jpg"
    ],
    category: "Assault Rifles, Poland, NATO Standard, Eastern Bloc, Modern Tactical",
    origin: "Poland",
    caliber: "5.56x45mm NATO",
    likes: 71
  },
  {
    id: "sar21",
    title: "SAR-21",
    price: "60",
    description: "The super rare SAR-21 Assault Rifle is ONLY here at Battlefield Vegas! This Singaporean bullpup rifle features an integrated laser aiming module and 1.5x optical sight as standard, representing cutting-edge military technology.",
    images: [
      "/img/vegas-guns/SAR-21-Assault-Rifle-e1530224420361.jpg",
      "/img/vegas-guns/SAR-21-Assault-Rifle-e1530224420361 (1).jpg",
      "/img/vegas-guns/SAR-21-Assault-Rifle-e1530224420361 (2).jpg"
    ],
    category: "Assault Rifles, Singapore, Bullpup, NATO Standard, Modern Tactical, Collector's Item",
    origin: "Singapore",
    caliber: "5.56x45mm NATO",
    likes: 89
  },
  {
    id: "sar80",
    title: "SAR-80",
    price: "60",
    description: "From Singapore comes the SAR-80 Assault Rifle! Developed in the 1970s with assistance from Sterling Armament, this rifle served as Singapore's standard military rifle before being replaced by the SAR-21.",
    images: [
      "/img/vegas-guns/SAR-80-Assault-Rifle.jpg",
      "/img/vegas-guns/SAR-80-Assault-Rifle (1).jpg",
      "/img/vegas-guns/SAR-80-Assault-Rifle (2).jpg"
    ],
    category: "Assault Rifles, Singapore, NATO Standard, Cold War",
    origin: "Singapore",
    caliber: "5.56x45mm NATO",
    likes: 38
  },
  {
    id: "daewoo_k2",
    title: "Daewoo K2",
    price: "60",
    description: "The South Korean K2 rifles are here! The Daewoo K2 is the standard service rifle of the Republic of Korea Armed Forces. Combining elements of the M16 and AK platforms, it's designed to perform in the harsh Korean peninsula climate.",
    images: [
      "/img/vegas-guns/Daewoo-K2-600px.jpg",
      "/img/vegas-guns/Daewoo-K2-600px (1).jpg",
      "/img/vegas-guns/Daewoo-K2-600px (2).jpg"
    ],
    category: "Assault Rifles, South Korea, NATO Standard, Modern Tactical, Battle Tested",
    origin: "South Korea",
    caliber: "5.56x45mm NATO",
    likes: 67
  },
  {
    id: "acr",
    title: "ACR",
    price: "60",
    description: "The ACR Assault Rifle, initially known as the Masada, is here ready to tear up the range! This modular rifle system allows for quick barrel and caliber changes, making it one of the most adaptable platforms available.",
    images: [
      "/img/vegas-guns/ACR2.jpg",
      "/img/vegas-guns/ACR2 (1).jpg",
      "/img/vegas-guns/ACR2 (2).jpg"
    ],
    category: "Assault Rifles, United States, NATO Standard, Modern Tactical, Video Game Famous",
    origin: "United States",
    caliber: "5.56x45mm NATO",
    likes: 134
  },
  {
    id: "vz58",
    title: "Vz 58",
    price: "60",
    description: "'Check' out the Czech VZ-58! Despite its visual similarity to the AK-47, the Vz 58 uses a completely different short-stroke gas piston system and tilting bolt. Lighter and more accurate than its Soviet counterpart.",
    images: [
      "/img/vegas-guns/Vz-58-Assault-Rifle-e1530310511683.jpg",
      "/img/vegas-guns/Vz-58-Assault-Rifle-e1530310511683 (1).jpg",
      "/img/vegas-guns/Vz-58-Assault-Rifle-e1530310511683 (2).jpg"
    ],
    category: "Assault Rifles, Czech Republic, Eastern Bloc, Cold War, Battle Tested",
    origin: "Czech Republic",
    caliber: "7.62x39mm",
    likes: 76
  },
  {
    id: "amd65",
    title: "AMD-65",
    price: "60",
    description: "The Hungarian AMD-65, used by Iraqi government troops and featured in the movie Rambo 3! This compact AK variant features a distinctive forward pistol grip and wire folding stock, designed for armored vehicle crews.",
    images: [
      "/img/vegas-guns/AMD-65.jpg",
      "/img/vegas-guns/AMD-65 (1).jpg",
      "/img/vegas-guns/AMD-65 (2).jpg"
    ],
    category: "Assault Rifles, Hungary, Eastern Bloc, Cold War, Movie Famous",
    origin: "Hungary",
    caliber: "7.62x39mm",
    likes: 82
  },
  {
    id: "armalite_ar180",
    title: "Armalite AR-180",
    price: "60",
    description: "The grandfather of most modern Western assault rifles, it's the Armalite AR-180! Designed as a simplified version of the AR-15 that could be manufactured without sophisticated machinery, its short-stroke gas piston system influenced countless modern designs.",
    images: [
      "/img/vegas-guns/AR-180.jpg",
      "/img/vegas-guns/AR-180 (1).jpg",
      "/img/vegas-guns/AR-180 (2).jpg"
    ],
    category: "Assault Rifles, United States, NATO Standard, Cold War, Collector's Item",
    origin: "United States",
    caliber: "5.56x45mm NATO",
    likes: 65
  },
  {
    id: "l1a1",
    title: "L1A1",
    price: "60",
    description: "The United Kingdom's main battle rifle, also known as the Free World's Right Hand! The L1A1 is the British version of the FN FAL, serving from 1954 until replaced by the SA80 in the 1980s. A true Cold War classic.",
    images: [
      "/img/vegas-guns/L1A1-Main-Battle-Rifle.jpg",
      "/img/vegas-guns/L1A1-Main-Battle-Rifle (1).jpg",
      "/img/vegas-guns/L1A1-Main-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, Great Britain, NATO Standard, Cold War, Battle Tested, Collector's Item",
    origin: "Great Britain",
    caliber: "7.62x51mm NATO",
    likes: 94
  },
  {
    id: "fn_fal",
    title: "FN FAL",
    price: "50",
    description: "Shoot the 'Free World's Right Arm'! The FN FAL is one of the most widely used rifles in history, adopted by over 90 countries. This Belgian battle rifle earned its nickname during the Cold War as the primary rifle of NATO and Western-aligned nations.",
    images: [
      "/img/vegas-guns/FN-FAL-Main-Battle-Rifle.jpg",
      "/img/vegas-guns/FN-FAL-Main-Battle-Rifle (1).jpg",
      "/img/vegas-guns/FN-FAL-Main-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, Belgium, NATO Standard, Cold War, Battle Tested, Collector's Item, Movie Famous",
    origin: "Belgium",
    caliber: "7.62x51mm NATO",
    likes: 156
  },
  {
    id: "mas_49_56",
    title: "MAS-1949/56",
    price: "60",
    description: "Go into combat with the MAS-1949/56 Battle Rifle! This French semi-automatic rifle served the French military through the Algerian War and beyond. Its direct-impingement gas system predates and influenced the AR-15 design.",
    images: [
      "/img/vegas-guns/MAS-194956-Battle-Rifle.jpg",
      "/img/vegas-guns/MAS-194956-Battle-Rifle (1).jpg",
      "/img/vegas-guns/MAS-194956-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, France, Cold War, Battle Tested, Collector's Item",
    origin: "France",
    caliber: "7.5x54mm French",
    likes: 52
  },

  // ============================================
  // WWII ERA RIFLES
  // ============================================
  {
    id: "m1_garand",
    title: "M1 Garand",
    price: "60",
    description: "M1 Garand battle rifle used by the Allies during WWII! General George S. Patton called it 'the greatest battle implement ever devised.' This semi-automatic rifle gave American soldiers a significant advantage over bolt-action equipped enemies.",
    images: [
      "/img/vegas-guns/M1-Garand-Main-Battle-Rifle.jpg",
      "/img/vegas-guns/M1-Garand-Main-Battle-Rifle (1).jpg",
      "/img/vegas-guns/M1-Garand-Main-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, United States, WWII, Korean War, Battle Tested, Collector's Item, Movie Famous, Video Game Famous, Beginner Friendly, Top Rated",
    origin: "United States",
    caliber: ".30-06 Springfield",
    likes: 287
  },
  {
    id: "m1a1_paratrooper",
    title: "M1A1 Paratrooper Carbine",
    price: "60",
    description: "Check out the M1A1 Paratrooper Carbine! This folding-stock variant of the M1 Carbine was designed specifically for airborne troops. Lighter than the M1 Garand, it was easier to carry during parachute jumps.",
    images: [
      "/img/vegas-guns/M1A1-Paratrooper-Carbine.jpg",
      "/img/vegas-guns/M1A1-Paratrooper-Carbine (1).jpg",
      "/img/vegas-guns/M1A1-Paratrooper-Carbine (2).jpg"
    ],
    category: "Carbines, United States, WWII, Battle Tested, Movie Famous, Video Game Famous",
    origin: "United States",
    caliber: ".30 Carbine",
    likes: 134
  },
  {
    id: "g43",
    title: "G-43",
    price: "60",
    description: "A genuine piece of history captured by US troops at the end of the war. This rifle still has the military markings and stampings from World War II Nazi Germany. The G-43 was Germany's answer to the Soviet SVT-40 and American M1 Garand.",
    images: [
      "/img/vegas-guns/G-43-Main-Battle-Rifle.jpg",
      "/img/vegas-guns/G-43-Main-Battle-Rifle (1).jpg",
      "/img/vegas-guns/G-43-Main-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, Germany, WWII, Battle Tested, Collector's Item",
    origin: "Germany",
    caliber: "7.92x57mm Mauser",
    likes: 98
  },
  {
    id: "lee_enfield_no1_mk3",
    title: "Lee-Enfield No. 1 Mk III",
    price: "35",
    description: "Lee Enfield main battle rifle used by the Allied forces during WWI and WWII! The fastest bolt-action military rifle ever made, a trained soldier could fire 20-30 aimed rounds per minute. The Mad Minute is legendary.",
    images: [
      "/img/vegas-guns/Lee-Enfield-No--1-Mk-III-Battle-Rifle.jpg",
      "/img/vegas-guns/Lee-Enfield-No--1-Mk-III-Battle-Rifle (1).jpg",
      "/img/vegas-guns/Lee-Enfield-No--1-Mk-III-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, Great Britain, WWI, WWII, Battle Tested, Collector's Item, Beginner Friendly",
    origin: "Great Britain",
    caliber: ".303 British",
    likes: 145
  },
  {
    id: "lee_enfield_no4_mk1",
    title: "Lee-Enfield No. 4 Mk I",
    price: "35",
    description: "Check out the heavy target barreled Lee-Enfield No. 4 Mk I Battle Rifle! This WWII-era improvement of the Lee-Enfield design featured simplified manufacturing and improved sights while maintaining the fast bolt action.",
    images: [
      "/img/vegas-guns/Lee-Enfield-No--4-Mk-I-Battle-Rifle.jpg",
      "/img/vegas-guns/Lee-Enfield-No--4-Mk-I-Battle-Rifle (1).jpg",
      "/img/vegas-guns/Lee-Enfield-No--4-Mk-I-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, Great Britain, WWII, Battle Tested, Collector's Item",
    origin: "Great Britain",
    caliber: ".303 British",
    likes: 87
  },
  {
    id: "mauser_98k",
    title: "Mauser 98K",
    price: "35",
    description: "The 98K, or Karabiner 98, was the workhorse of the German Army during World War II. This legendary bolt-action rifle is renowned for its accuracy and reliability. The Mauser action it's based on is still used in sporting rifles today.",
    images: [
      "/img/vegas-guns/Mauser-98K-Main-Battle-Rifle.jpg",
      "/img/vegas-guns/Mauser-98K-Main-Battle-Rifle (1).jpg",
      "/img/vegas-guns/Mauser-98K-Main-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, Germany, WWII, Battle Tested, Collector's Item, Movie Famous, Video Game Famous, Beginner Friendly",
    origin: "Germany",
    caliber: "7.92x57mm Mauser",
    likes: 198
  },
  {
    id: "mosin_nagant",
    title: "Mosin-Nagant M91/30",
    price: "29.99",
    description: "Mosin-Nagants are the longest serving battle rifles in the world's history! First adopted in 1891, this Russian rifle served through two World Wars and countless conflicts. Its simple, robust design keeps it in use even today.",
    images: [
      "/img/vegas-guns/Mosin-Nagant-M9130-Battle-Rifle.jpg",
      "/img/vegas-guns/Mosin-Nagant-M9130-Battle-Rifle (1).jpg",
      "/img/vegas-guns/Mosin-Nagant-M9130-Battle-Rifle (2).jpg"
    ],
    category: "Battle Rifles, Russia, WWII, Eastern Bloc, Battle Tested, Collector's Item, Video Game Famous, Beginner Friendly",
    origin: "Russia",
    caliber: "7.62x54mmR",
    likes: 167
  },
  {
    id: "svt40",
    title: "SVT-40",
    price: "60",
    description: "SVT-40 battle rifle used by the Soviets during WWII! This semi-automatic rifle was ahead of its time, though its complexity made it less popular than the simpler Mosin-Nagant with regular troops. Elite Soviet snipers and marines favored it.",
    images: [
      "/img/vegas-guns/SVT-40-Main-Battle-Rifle-e1530224381572.jpg",
      "/img/vegas-guns/SVT-40-Main-Battle-Rifle-e1530224381572 (1).jpg",
      "/img/vegas-guns/SVT-40-Main-Battle-Rifle-e1530224381572 (2).jpg"
    ],
    category: "Battle Rifles, Russia, WWII, Eastern Bloc, Battle Tested, Collector's Item",
    origin: "Russia",
    caliber: "7.62x54mmR",
    likes: 89
  },
  {
    id: "sks",
    title: "Type-56 / SKS",
    price: "60",
    description: "Try the Type-56 / SKS Carbine! This Soviet-designed semi-automatic carbine bridged the gap between WWII rifles and the AK-47. The Chinese Type-56 variant saw extensive use in the Vietnam War on the opposing side.",
    images: [
      "/img/vegas-guns/Type-56-Carbine-.jpg",
      "/img/vegas-guns/Type-56-Carbine- (1).jpg",
      "/img/vegas-guns/Type-56-Carbine- (2).jpg"
    ],
    category: "Carbines, China, Vietnam, Eastern Bloc, Battle Tested, Video Game Famous, Beginner Friendly",
    origin: "China",
    caliber: "7.62x39mm",
    likes: 112
  },

  // ============================================
  // SUBMACHINE GUNS
  // ============================================
  {
    id: "hk_mp5a3",
    title: "HK MP5-A3",
    price: "55",
    description: "Take aim with the HK MP5-A3 SMG! The MP5 is one of the most widely used submachine guns in the world. This variant features a retractable stock for compact storage while maintaining full-size performance. A favorite of counter-terrorist units worldwide.",
    images: [
      "/img/vegas-guns/HK-MP5-A3-SMG.jpg",
      "/img/vegas-guns/HK-MP5-A3-SMG (1).jpg",
      "/img/vegas-guns/HK-MP5-A3-SMG (2).jpg"
    ],
    category: "Submachine Guns, Germany, NATO Standard, Modern Tactical, Movie Famous, Video Game Famous, Top Rated",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 234
  },
  {
    id: "hk_mp5sd",
    title: "HK MP5-SD",
    price: "55",
    description: "Restock and reload with the HK MP5-SD SMG! The SD variant features an integrated suppressor, making it one of the quietest submachine guns ever made. Perfect for covert operations and special forces use.",
    images: [
      "/img/vegas-guns/HK-MP5-SD-SMG.jpg",
      "/img/vegas-guns/HK-MP5-SD-SMG (1).jpg",
      "/img/vegas-guns/HK-MP5-SD-SMG (2).jpg"
    ],
    category: "Submachine Guns, Germany, NATO Standard, Modern Tactical, Suppressed, Movie Famous",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 189
  },
  {
    id: "hk_mp5k",
    title: "HK MP5K",
    price: "55",
    description: "Reserve your HK MP5K SMG today! The K variant is the ultra-compact version of the MP5, designed for close protection and concealed carry. Despite its small size, it maintains the legendary MP5 reliability.",
    images: [
      "/img/vegas-guns/HK-MP5K-SMG-e1531167774306.jpg",
      "/img/vegas-guns/HK-MP5K-SMG-e1531167774306 (1).jpg",
      "/img/vegas-guns/HK-MP5K-SMG-e1531167774306 (2).jpg"
    ],
    category: "Submachine Guns, Germany, NATO Standard, Modern Tactical, Movie Famous, Video Game Famous",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 167
  },
  {
    id: "hk_mp7a1",
    title: "HK MP7A1",
    price: "95",
    description: "Take aim with the ONLY MP7's in Las Vegas! The MP7 is a personal defense weapon designed to penetrate body armor. Its unique 4.6x30mm cartridge offers superior penetration compared to standard pistol rounds.",
    images: [
      "/img/vegas-guns/HK-MP7A1-SMG.jpg",
      "/img/vegas-guns/HK-MP7A1-SMG (1).jpg",
      "/img/vegas-guns/HK-MP7A1-SMG (2).jpg"
    ],
    category: "Submachine Guns, Germany, NATO Standard, Modern Tactical, Video Game Famous, Top Rated",
    origin: "Germany",
    caliber: "4.6x30mm",
    likes: 256
  },
  {
    id: "hk_ump45",
    title: "HK UMP-45",
    price: "55",
    description: "Fire the HK UMP-45 SMG only at Battlefield Vegas! The UMP was designed as a lighter, cheaper alternative to the MP5, chambered in the powerful .45 ACP cartridge for maximum stopping power.",
    images: [
      "/img/vegas-guns/HK-UMP-45-SMG.jpg",
      "/img/vegas-guns/HK-UMP-45-SMG (1).jpg",
      "/img/vegas-guns/HK-UMP-45-SMG (2).jpg"
    ],
    category: "Submachine Guns, Germany, NATO Standard, Modern Tactical, Video Game Famous",
    origin: "Germany",
    caliber: ".45 ACP",
    likes: 145
  },
  {
    id: "uzi",
    title: "Uzi",
    price: "55",
    description: "Fire the Uzi SMG at Battlefield Vegas today! This iconic Israeli submachine gun revolutionized compact firearm design. Its simple blowback operation and compact size made it a favorite of military and security forces worldwide.",
    images: [
      "/img/vegas-guns/Uzi-SMG.jpg",
      "/img/vegas-guns/Uzi-SMG (1).jpg",
      "/img/vegas-guns/Uzi-SMG (2).jpg"
    ],
    category: "Submachine Guns, Israel, Cold War, Battle Tested, Movie Famous, Video Game Famous, Top Rated",
    origin: "Israel",
    caliber: "9x19mm Parabellum",
    likes: 278
  },
  {
    id: "colt_9mm_smg",
    title: "Colt 9mm SMG",
    price: "55",
    description: "Fire the Colt 9mm SMG at Battlefield Vegas! Based on the M16/AR-15 platform, this submachine gun offers familiar controls for those trained on American rifles while chambered in 9mm for reduced recoil.",
    images: [
      "/img/vegas-guns/Colt-9mm-SMG.jpg",
      "/img/vegas-guns/Colt-9mm-SMG (1).jpg",
      "/img/vegas-guns/Colt-9mm-SMG (2).jpg"
    ],
    category: "Submachine Guns, United States, NATO Standard, Modern Tactical",
    origin: "United States",
    caliber: "9x19mm Parabellum",
    likes: 87
  },
  {
    id: "swedish_k",
    title: "Carl Gustav 'Swedish K'",
    price: "55",
    description: "From the Vietnam War to the conflict in Ukraine, the Carl Gustav 'Swedish K' SMG is at Battlefield Vegas! This rugged Swedish design was favored by US Navy SEALs in Vietnam for its reliability in harsh conditions.",
    images: [
      "/img/vegas-guns/Carl-Gustav-22Swedish-K22-SMG-e1531158532500.jpg",
      "/img/vegas-guns/Carl-Gustav-22Swedish-K22-SMG-e1531158532500 (1).jpg",
      "/img/vegas-guns/Carl-Gustav-22Swedish-K22-SMG-e1531158532500 (2).jpg"
    ],
    category: "Submachine Guns, Sweden, Vietnam, Cold War, Battle Tested, Collector's Item",
    origin: "Sweden",
    caliber: "9x19mm Parabellum",
    likes: 98
  },
  {
    id: "evo3_scorpion",
    title: "Evo 3 Scorpion",
    price: "55",
    description: "Shoot the compact Evo 3 Scorpion SMG at Battlefield Vegas! This modern Czech design offers exceptional ergonomics and accuracy in a compact package. A favorite in competitive shooting sports.",
    images: [
      "/img/vegas-guns/Evo-3-Scorpion-SMG-.jpg",
      "/img/vegas-guns/Evo-3-Scorpion-SMG- (1).jpg",
      "/img/vegas-guns/Evo-3-Scorpion-SMG- (2).jpg"
    ],
    category: "Submachine Guns, Czech Republic, Modern Tactical, Video Game Famous",
    origin: "Czech Republic",
    caliber: "9x19mm Parabellum",
    likes: 156
  },
  {
    id: "fn_p90",
    title: "FN P90",
    price: "95",
    description: "Shoot the personal defense FN P90 SMG at Battlefield Vegas! This futuristic Belgian PDW features a unique top-mounted magazine and fires armor-piercing 5.7x28mm rounds. Iconic from countless movies and video games.",
    images: [
      "/img/vegas-guns/FN-P90-SMG.jpg",
      "/img/vegas-guns/FN-P90-SMG (1).jpg",
      "/img/vegas-guns/FN-P90-SMG (2).jpg"
    ],
    category: "Submachine Guns, Belgium, NATO Standard, Modern Tactical, Movie Famous, Video Game Famous, Top Rated",
    origin: "Belgium",
    caliber: "5.7x28mm",
    likes: 312
  },
  {
    id: "sig_mpx",
    title: "SIG MPX",
    price: "55",
    description: "Reserve your SIG MPX SMG today with Battlefield Vegas! This modern submachine gun uses a short-stroke gas piston system for enhanced reliability. Adopted by numerous law enforcement agencies.",
    images: [
      "/img/vegas-guns/SIG-MPX-SMG.jpg",
      "/img/vegas-guns/SIG-MPX-SMG (1).jpg"
    ],
    category: "Submachine Guns, Switzerland, NATO Standard, Modern Tactical",
    origin: "Switzerland",
    caliber: "9x19mm Parabellum",
    likes: 134
  },
  {
    id: "hotchkiss_utg",
    title: "Hotchkiss UTG",
    price: "55",
    description: "The Hotchkiss UTG SMG is a great choice here at Battlefield Vegas. This rare French submachine gun represents Cold War era European design philosophy.",
    images: [
      "/img/vegas-guns/Hotchkiss-UTG-SMG.jpg",
      "/img/vegas-guns/Hotchkiss-UTG-SMG (1).jpg"
    ],
    category: "Submachine Guns, France, Cold War, Collector's Item",
    origin: "France",
    caliber: "9x19mm Parabellum",
    likes: 45
  },
  {
    id: "vz61_scorpion",
    title: "Vz 61 Scorpion",
    price: "35",
    description: "The Vz 61 Machine Pistol is a great way to have fun in Vegas! This compact Czech machine pistol can be fired with one hand and was designed for vehicle crews and special operations forces.",
    images: [
      "/img/vegas-guns/Vz-61-Machine-Pistol.jpg",
      "/img/vegas-guns/Vz-61-Machine-Pistol (1).jpg"
    ],
    category: "Submachine Guns, Czech Republic, Cold War, Eastern Bloc, Movie Famous",
    origin: "Czech Republic",
    caliber: ".32 ACP",
    likes: 89
  },
  {
    id: "m3a1_grease_gun",
    title: "M3A1 'Grease Gun'",
    price: "55",
    description: "Take aim with the M3A1 'Grease Gun' SMG from Battlefield Vegas! Named for its resemblance to a mechanic's grease gun, this WWII-era SMG was designed as a cheaper alternative to the Thompson.",
    images: [
      "/img/vegas-guns/M3A1-22Grease-Gun22-SMG.jpg",
      "/img/vegas-guns/M3A1-22Grease-Gun22-SMG (1).jpg"
    ],
    category: "Submachine Guns, United States, WWII, Korean War, Battle Tested, Video Game Famous",
    origin: "United States",
    caliber: ".45 ACP",
    likes: 134
  },
  {
    id: "thompson_m1928",
    title: "Thompson M-1928",
    price: "55",
    description: "Try firing the Thompson M-1928 SMG at Battlefield Vegas! The 'Tommy Gun' is one of the most iconic firearms in history, famous from Prohibition-era gangster movies and WWII combat.",
    images: [
      "/img/vegas-guns/Thompson-M-1928-SMG.jpg",
      "/img/vegas-guns/Thompson-M-1928-SMG (1).jpg"
    ],
    category: "Submachine Guns, United States, WWII, Battle Tested, Movie Famous, Collector's Item, Top Rated",
    origin: "United States",
    caliber: ".45 ACP",
    likes: 289
  },
  {
    id: "thompson_m1a1",
    title: "Thompson M1A1",
    price: "55",
    description: "Reserve the Thompson M1A1 SMG from Battlefield Vegas today! The simplified wartime version of the legendary Tommy Gun, this variant saw extensive service in WWII and Korea.",
    images: [
      "/img/vegas-guns/Thompson-M1A1-SMG.jpg",
      "/img/vegas-guns/Thompson-M1A1-SMG (1).jpg"
    ],
    category: "Submachine Guns, United States, WWII, Korean War, Battle Tested, Movie Famous, Video Game Famous",
    origin: "United States",
    caliber: ".45 ACP",
    likes: 245
  },
  {
    id: "mp40",
    title: "MP-40",
    price: "55",
    description: "Have a blast with the MP-40 SMG at Battlefield Vegas! This iconic German WWII submachine gun was one of the first to use a folding stock and synthetic materials in its construction.",
    images: [
      "/img/vegas-guns/MP-40-SMG.jpg",
      "/img/vegas-guns/MP-40-SMG (1).jpg"
    ],
    category: "Submachine Guns, Germany, WWII, Battle Tested, Movie Famous, Video Game Famous, Collector's Item",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 267
  },
  {
    id: "pm06",
    title: "PM-06",
    price: "55",
    description: "Reserve the PM-06 SMG today from Battlefield Vegas! This Polish submachine gun represents Eastern Bloc ingenuity during the Cold War era.",
    images: [
      "/img/vegas-guns/PM-06-SMG.jpg",
      "/img/vegas-guns/PM-06-SMG (1).jpg"
    ],
    category: "Submachine Guns, Poland, Cold War, Eastern Bloc",
    origin: "Poland",
    caliber: "9x19mm Parabellum",
    likes: 56
  },
  {
    id: "pps43",
    title: "PPS-43",
    price: "55",
    description: "One of the Call of Duty classics is here at Battlefield Vegas! The PPS-43 was designed during the Siege of Leningrad as a simple, reliable submachine gun that could be mass-produced.",
    images: [
      "/img/vegas-guns/PPS-43-SMG.jpg",
      "/img/vegas-guns/PPS-43-SMG (1).jpg"
    ],
    category: "Submachine Guns, Russia, WWII, Eastern Bloc, Battle Tested, Video Game Famous",
    origin: "Russia",
    caliber: "7.62x25mm Tokarev",
    likes: 123
  },
  {
    id: "ppsh41",
    title: "PPSh-41",
    price: "55",
    description: "Prepare for all out fun with the 'Papa Shaw' or PPSh-41 SMG at Battlefield Vegas! This Soviet WWII submachine gun with its distinctive drum magazine helped turn the tide on the Eastern Front.",
    images: [
      "/img/vegas-guns/PPSh-41-SMG.jpg",
      "/img/vegas-guns/PPSh-41-SMG (1).jpg"
    ],
    category: "Submachine Guns, Russia, WWII, Eastern Bloc, Battle Tested, Movie Famous, Video Game Famous, Top Rated",
    origin: "Russia",
    caliber: "7.62x25mm Tokarev",
    likes: 234
  },
  {
    id: "pm63",
    title: "PM-63 RAK",
    price: "55",
    description: "Have fun with the RAK PM-63 SMG at Battlefield Vegas! This Polish machine pistol features a unique rate reducer and can be fired one-handed.",
    images: [
      "/img/vegas-guns/RAK-PM-63-SMG-Pistol.jpg",
      "/img/vegas-guns/RAK-PM-63-SMG-Pistol (1).jpg"
    ],
    category: "Submachine Guns, Poland, Cold War, Eastern Bloc",
    origin: "Poland",
    caliber: "9x18mm Makarov",
    likes: 67
  },
  {
    id: "sten_mk2",
    title: "Sten Mk II",
    price: "55",
    description: "The Sten Mk II SMG will give you chills at Battlefield Vegas! This British WWII submachine gun was designed for mass production, costing only about $10 to manufacture.",
    images: [
      "/img/vegas-guns/Sten-Mk-II-SMG.jpg",
      "/img/vegas-guns/Sten-Mk-II-SMG (1).jpg"
    ],
    category: "Submachine Guns, Great Britain, WWII, Battle Tested, Video Game Famous, Collector's Item",
    origin: "Great Britain",
    caliber: "9x19mm Parabellum",
    likes: 156
  },
  {
    id: "sten_mk5",
    title: "Sten Mk V",
    price: "55",
    description: "Reserve the Sten Mk V SMG from Battlefield Vegas today! The final and most refined version of the Sten, featuring improved quality and a wooden stock.",
    images: [
      "/img/vegas-guns/Sten-Mk-V-SMG.jpg",
      "/img/vegas-guns/Sten-Mk-V-SMG (1).jpg"
    ],
    category: "Submachine Guns, Great Britain, WWII, Battle Tested, Collector's Item",
    origin: "Great Britain",
    caliber: "9x19mm Parabellum",
    likes: 98
  },
  {
    id: "sterling_l34a1",
    title: "Sterling L-34A1 Suppressed",
    price: "55",
    description: "Take on the Sterling L-34A1 Suppressed SMG at Battlefield Vegas! This suppressed variant of the Sterling was used by British special forces for covert operations.",
    images: [
      "/img/vegas-guns/Sterling-L-34A1-Suppressed-SMG.jpg",
      "/img/vegas-guns/Sterling-L-34A1-Suppressed-SMG (1).jpg"
    ],
    category: "Submachine Guns, Great Britain, Australia, Cold War, Suppressed, Battle Tested",
    origin: "Great Britain",
    caliber: "9x19mm Parabellum",
    likes: 112
  },
  {
    id: "sterling_l2a3",
    title: "Sterling L2A3",
    price: "55",
    description: "Fire rounds with the Sterling L2A3 SMG at Battlefield Vegas! Famous as the basis for Star Wars Stormtrooper blasters, this British SMG served from 1944 to 1994.",
    images: [
      "/img/vegas-guns/Sterling-L2A3-SMG.jpg",
      "/img/vegas-guns/Sterling-L2A3-SMG (1).jpg"
    ],
    category: "Submachine Guns, Great Britain, Cold War, Battle Tested, Movie Famous",
    origin: "Great Britain",
    caliber: "9x19mm Parabellum",
    likes: 145
  },
  {
    id: "steyr_mpi69",
    title: "Steyr MPi-69",
    price: "55",
    description: "You won't regret using the Steyr MPi-69 SMG at Battlefield Vegas! This Austrian submachine gun features a unique sling that doubles as a charging handle.",
    images: [
      "/img/vegas-guns/Steyr-MPi-69-SMG.jpg",
      "/img/vegas-guns/Steyr-MPi-69-SMG (1).jpg"
    ],
    category: "Submachine Guns, Austria, Cold War",
    origin: "Austria",
    caliber: "9x19mm Parabellum",
    likes: 67
  },
  {
    id: "steyr_mpi81",
    title: "Steyr MPi-81",
    price: "55",
    description: "Add this bad boy to your cart! The Steyr MPi-81 SMG will be sure to turn heads. An improved version of the MPi-69 with enhanced reliability.",
    images: [
      "/img/vegas-guns/Steyr-MPi-81-SMG.jpg",
      "/img/vegas-guns/Steyr-MPi-81-SMG (1).jpg"
    ],
    category: "Submachine Guns, Austria, Cold War",
    origin: "Austria",
    caliber: "9x19mm Parabellum",
    likes: 56
  },
  {
    id: "madsen_m50",
    title: "Madsen M-50",
    price: "55",
    description: "Reserve the Madsen M-50 SMG at Battlefield Vegas! This Danish submachine gun features a unique curved magazine and was exported to numerous countries.",
    images: [
      "/img/vegas-guns/Madsen-M-50-SMG.jpg",
      "/img/vegas-guns/Madsen-M-50-SMG (1).jpg"
    ],
    category: "Submachine Guns, Denmark, Cold War, Collector's Item",
    origin: "Denmark",
    caliber: "9x19mm Parabellum",
    likes: 45
  },
  {
    id: "walther_mplk",
    title: "Walther MPL-K",
    price: "55",
    description: "Reserve your Walther MPL-K SMG today at Battlefield Vegas! This German submachine gun was designed for police and military use with excellent accuracy.",
    images: [
      "/img/vegas-guns/Walther-MPL-K-SMG.jpg",
      "/img/vegas-guns/Walther-MPL-K-SMG (1).jpg"
    ],
    category: "Submachine Guns, Germany, Cold War",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 78
  },
  {
    id: "beretta_pm12",
    title: "Beretta PM-12",
    price: "55",
    description: "Developed in the 1950's, this Beretta SMG will not disappoint! The PM-12 was the standard Italian military submachine gun for decades.",
    images: [
      "/img/vegas-guns/Beretta-PM-12-SMG1-e1531157963576.jpg",
      "/img/vegas-guns/Beretta-PM-12-SMG1-e1531157963576 (1).jpg"
    ],
    category: "Submachine Guns, Italy, Cold War, Battle Tested",
    origin: "Italy",
    caliber: "9x19mm Parabellum",
    likes: 89
  },
  {
    id: "suomi_kp31",
    title: "Suomi KP-31",
    price: "55",
    description: "The Suomi KP-31 SMG - a Finnish masterpiece! This submachine gun with its distinctive drum magazine proved devastating during the Winter War against the Soviet Union.",
    images: [
      "/img/vegas-guns/Soumi-600px.jpg",
      "/img/vegas-guns/Soumi-600px (1).jpg"
    ],
    category: "Submachine Guns, Finland, WWII, Battle Tested, Collector's Item",
    origin: "Finland",
    caliber: "9x19mm Parabellum",
    likes: 112
  },
  {
    id: "mp18",
    title: "MP-18",
    price: "55",
    description: "The German trench-clearing MP-18 from WWI is here only at Battlefield Vegas. The world's first practical submachine gun, it revolutionized infantry warfare.",
    images: [
      "/img/vegas-guns/MP18.jpg"
    ],
    category: "Submachine Guns, Germany, WWI, Battle Tested, Collector's Item",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 134
  },
  {
    id: "mp28",
    title: "MP-28/II",
    price: "55",
    description: "MP-28/II used from WWII and even during the Vietnam War! An improved version of the MP-18 with select-fire capability.",
    images: [
      "/img/vegas-guns/MP28-600px.jpg"
    ],
    category: "Submachine Guns, Germany, WWII, Vietnam, Battle Tested, Collector's Item",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 98
  },
  {
    id: "mp34",
    title: "MP-34",
    price: "55",
    description: "The SMG used by Germans to get around Treaty restrictions! This Austrian-made submachine gun was of exceptional quality.",
    images: [
      "/img/vegas-guns/MP34-600px.jpg"
    ],
    category: "Submachine Guns, Austria, WWII, Collector's Item",
    origin: "Austria",
    caliber: "9x19mm Parabellum",
    likes: 87
  },
  {
    id: "bt_apc9",
    title: "B&T APC 9mm",
    price: "55",
    description: "Reserve your B&T APC9 SMG today with Battlefield Vegas! This Swiss submachine gun represents the pinnacle of modern SMG design.",
    images: [
      "/img/vegas-guns/BT9-600px.jpg",
      "/img/vegas-guns/BT9-600px (1).jpg"
    ],
    category: "Submachine Guns, Switzerland, Modern Tactical",
    origin: "Switzerland",
    caliber: "9x19mm Parabellum",
    likes: 145
  },
  {
    id: "owen_mk1",
    title: "Owen Mk1",
    price: "55",
    description: "Take on Australia's very own Owen SMG at Battlefield Vegas! This Australian-designed SMG proved extremely reliable in the jungles of the Pacific theater.",
    images: [
      "/img/vegas-guns/Ownen-SMG-for-website.jpeg"
    ],
    category: "Submachine Guns, Australia, WWII, Battle Tested, Collector's Item",
    origin: "Australia",
    caliber: "9x19mm Parabellum",
    likes: 98
  },
  {
    id: "mat49",
    title: "MAT-49",
    price: "55",
    description: "From the deserts of Africa to the jungles of Vietnam, the French MAT-49 sub-machinegun is a great choice here at Battlefield Vegas. Used extensively during French colonial conflicts.",
    images: [
      "/img/vegas-guns/MAT-49-600px-stock.jpg"
    ],
    category: "Submachine Guns, France, Vietnam, Cold War, Battle Tested",
    origin: "France",
    caliber: "9x19mm Parabellum",
    likes: 89
  },

  // ============================================
  // MACHINE GUNS
  // ============================================
  {
    id: "m2_browning",
    title: "M2 Browning 'Ma Deuce'",
    price: "350",
    description: "The M2HB or 'Ma Deuce' is available here in Las Vegas for you! This legendary .50 caliber machine gun has been in service since 1933 and remains the standard heavy machine gun for US forces.",
    images: [
      "/img/vegas-guns/M2-Browning-22Ma-Deuce22-Machine-Gun.jpg",
      "/img/vegas-guns/M2-Browning-22Ma-Deuce22-Machine-Gun (1).jpg",
      "/img/vegas-guns/M2-Browning-22Ma-Deuce22-Machine-Gun (2).jpg"
    ],
    category: "Machine Guns, United States, Belt-Fed, WWII, Korean War, Vietnam, Battle Tested, Movie Famous, Top Rated, Advanced",
    origin: "United States",
    caliber: ".50 BMG",
    likes: 456
  },
  {
    id: "m249_saw",
    title: "M-249 SAW",
    price: "80",
    description: "The M249 is the current US military issue Squad Automatic Weapon serving around the world. This belt-fed light machine gun provides sustained firepower at the squad level.",
    images: [
      "/img/vegas-guns/PEO_M249_Para_ACOG.jpg",
      "/img/vegas-guns/PEO_M249_Para_ACOG (1).jpg",
      "/img/vegas-guns/PEO_M249_Para_ACOG (2).jpg"
    ],
    category: "Machine Guns, United States, Belt-Fed, NATO Standard, Modern Tactical, Battle Tested, Video Game Famous, Top Rated",
    origin: "United States",
    caliber: "5.56x45mm NATO",
    likes: 312
  },
  {
    id: "m240",
    title: "M-240",
    price: "80",
    description: "The M240 has been used by the United States Armed Forces since the late-1970s. This reliable belt-fed machine gun serves in infantry, vehicle, and aircraft roles.",
    images: [
      "/img/vegas-guns/M-240-Belt-Fed-Machine-Gun.jpg",
      "/img/vegas-guns/M-240-Belt-Fed-Machine-Gun (1).jpg",
      "/img/vegas-guns/M-240-Belt-Fed-Machine-Gun (2).jpg"
    ],
    category: "Machine Guns, United States, Belt-Fed, NATO Standard, Modern Tactical, Battle Tested, Video Game Famous",
    origin: "United States",
    caliber: "7.62x51mm NATO",
    likes: 234
  },
  {
    id: "m60",
    title: "M60",
    price: "80",
    description: "There are several types of live ammunition approved for use in the M60, including ball, tracer, and armor-piercing rounds. The 'Pig' served as America's primary GPMG through Vietnam.",
    images: [
      "/img/vegas-guns/M60-Belt-Fed-Machine-Gun.jpg",
      "/img/vegas-guns/M60-Belt-Fed-Machine-Gun (1).jpg",
      "/img/vegas-guns/M60-Belt-Fed-Machine-Gun (2).jpg"
    ],
    category: "Machine Guns, United States, Belt-Fed, NATO Standard, Vietnam, Battle Tested, Movie Famous, Video Game Famous, Top Rated",
    origin: "United States",
    caliber: "7.62x51mm NATO",
    likes: 289
  },
  {
    id: "m60e6",
    title: "M60 E6",
    price: "80",
    description: "The current-issue M60-E6 is only available at Battlefield when visiting Las Vegas! This modernized variant of the M60 features improved reliability and ergonomics.",
    images: [
      "/img/vegas-guns/M60E6-600px-bright.jpg",
      "/img/vegas-guns/M60E6-600px-bright (1).jpg",
      "/img/vegas-guns/M60E6-600px-bright (2).jpg"
    ],
    category: "Machine Guns, United States, Belt-Fed, NATO Standard, Modern Tactical, Battle Tested",
    origin: "United States",
    caliber: "7.62x51mm NATO",
    likes: 178
  },
  {
    id: "l86a1",
    title: "L86A1 Squad Weapon",
    price: "80",
    description: "Fire the L86A1 Squad Weapon! Also known as the Light Support Weapon variant of the SA80 family, this British bullpup provides sustained fire capability.",
    images: [
      "/img/vegas-guns/L86A1-Squad-Weapon.jpg",
      "/img/vegas-guns/L86A1-Squad-Weapon (1).jpg",
      "/img/vegas-guns/L86A1-Squad-Weapon (2).jpg"
    ],
    category: "Machine Guns, Great Britain, Bullpup, NATO Standard, Modern Tactical, Battle Tested",
    origin: "Great Britain",
    caliber: "5.56x45mm NATO",
    likes: 78
  },
  {
    id: "rpd",
    title: "RPD",
    price: "80",
    description: "The RPD was used by NVA and Viet Cong forces in its early years. It's still in service with many countries today. This belt-fed light machine gun preceded the RPK.",
    images: [
      "/img/vegas-guns/RPD-Belt-Fed-Machine-Gun.jpg",
      "/img/vegas-guns/RPD-Belt-Fed-Machine-Gun (1).jpg",
      "/img/vegas-guns/RPD-Belt-Fed-Machine-Gun (2).jpg"
    ],
    category: "Machine Guns, Russia, Belt-Fed, Vietnam, Eastern Bloc, Battle Tested",
    origin: "Russia",
    caliber: "7.62x39mm",
    likes: 156
  },
  {
    id: "pkm",
    title: "PKM",
    price: "80",
    description: "The PKM is a 7.62mm general-purpose machine gun designed in the Soviet Union. Still in service in Syria, Afghanistan and other hotspots worldwide.",
    images: [
      "/img/vegas-guns/PKM-Machine-Gun.jpg",
      "/img/vegas-guns/PKM-Machine-Gun (1).jpg",
      "/img/vegas-guns/PKM-Machine-Gun (2).jpg"
    ],
    category: "Machine Guns, Russia, Belt-Fed, Eastern Bloc, Battle Tested, Video Game Famous",
    origin: "Russia",
    caliber: "7.62x54mmR",
    likes: 198
  },
  {
    id: "m1919_browning",
    title: "M1919 Browning",
    price: "80",
    description: "The M1919 Browning is a .30 caliber medium machine gun that was used during the 20th century. A workhorse of WWII and Korea.",
    images: [
      "/img/vegas-guns/M1919-Browning-Machine-Gun.jpg",
      "/img/vegas-guns/M1919-Browning-Machine-Gun (1).jpg",
      "/img/vegas-guns/M1919-Browning-Machine-Gun (2).jpg"
    ],
    category: "Machine Guns, United States, Belt-Fed, WWII, Korean War, Battle Tested, Collector's Item",
    origin: "United States",
    caliber: ".30-06 Springfield",
    likes: 167
  },
  {
    id: "m1919a4_beast",
    title: "M1919A4 'BEAST MODE'",
    price: "80",
    description: "Shoot The M1919A4 Machine Gun at Battlefield Vegas today! Experience the raw power of this WWII-era medium machine gun.",
    images: [
      "/img/vegas-guns/M1919A4-BEAST-MODE-Machine-Gun-image-1.jpg"
    ],
    category: "Machine Guns, United States, Belt-Fed, WWII, Battle Tested",
    origin: "United States",
    caliber: ".30-06 Springfield",
    likes: 145
  },
  {
    id: "mg13",
    title: "MG13",
    price: "80",
    description: "The MG 13 was a German general-purpose machine gun obtained by rebuilding a World War I water-cooled machine gun.",
    images: [
      "/img/vegas-guns/MG-13-Medium-Machine-Gun.jpg",
      "/img/vegas-guns/MG-13-Medium-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Germany, WWII, Collector's Item",
    origin: "Germany",
    caliber: "7.92x57mm Mauser",
    likes: 89
  },
  {
    id: "mg15",
    title: "MG15",
    price: "80",
    description: "The MG 15 was developed from the MG 30 which was designed by Rheinmetall. Originally an aircraft gun, it was later adapted for ground use.",
    images: [
      "/img/vegas-guns/MG-15-Medium-Machine-Gun.jpg",
      "/img/vegas-guns/MG-15-Medium-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Germany, WWII, Collector's Item",
    origin: "Germany",
    caliber: "7.92x57mm Mauser",
    likes: 78
  },
  {
    id: "mg34",
    title: "MG34",
    price: "80",
    description: "Fire the MG 34 machine gun in Las Vegas with Battlefield Vegas. The world's first general-purpose machine gun, it set the standard for all that followed.",
    images: [
      "/img/vegas-guns/MG-34-Machine-Gun.jpg",
      "/img/vegas-guns/MG-34-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Germany, Belt-Fed, WWII, Battle Tested, Video Game Famous, Collector's Item",
    origin: "Germany",
    caliber: "7.92x57mm Mauser",
    likes: 198
  },
  {
    id: "mg42",
    title: "MG42",
    price: "80",
    description: "Known as 'Hitler's Buzzsaw' the MG-42 has been in service since 1942 and is still in service today. Its incredible rate of fire made it one of the most feared weapons of WWII.",
    images: [
      "/img/vegas-guns/MG-42-Machine-Gun.jpg",
      "/img/vegas-guns/MG-42-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Germany, Belt-Fed, WWII, Battle Tested, Movie Famous, Video Game Famous, Top Rated",
    origin: "Germany",
    caliber: "7.92x57mm Mauser",
    likes: 345
  },
  {
    id: "mg0815",
    title: "MG-08/15",
    price: "80",
    description: "This is an original machine gun that was captured at the end of World War I. A lightened version of the famous Maxim gun for infantry use.",
    images: [
      "/img/vegas-guns/MG-0815-Medium-Machine-Gun.jpg",
      "/img/vegas-guns/MG-0815-Medium-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Germany, Belt-Fed, WWI, Battle Tested, Collector's Item",
    origin: "Germany",
    caliber: "7.92x57mm Mauser",
    likes: 134
  },
  {
    id: "lewis_gun",
    title: "Type 92 / Lewis Gun",
    price: "80",
    description: "The Type 92 Light Machine Gun was a light machine gun used by the Japanese Imperial forces during World War II. Based on the iconic Lewis Gun design.",
    images: [
      "/img/vegas-guns/Type-92-22Lewis-Gun22-Light-Machine-Gun.jpg",
      "/img/vegas-guns/Type-92-22Lewis-Gun22-Light-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Great Britain, Japan, WWII, Battle Tested, Movie Famous, Collector's Item",
    origin: "Great Britain",
    caliber: ".303 British",
    likes: 167
  },
  {
    id: "uk_vz59",
    title: "UK vz 59",
    price: "80",
    description: "The Universal Machine Gun Model 1959 is a machine gun developed in Czechoslovakia in the 1950s. A versatile GPMG design.",
    images: [
      "/img/vegas-guns/UK-vz-59-Machine-Gun.jpg",
      "/img/vegas-guns/UK-vz-59-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Czech Republic, Belt-Fed, Cold War, Eastern Bloc",
    origin: "Czech Republic",
    caliber: "7.62x54mmR",
    likes: 89
  },
  {
    id: "ultimax100",
    title: "Ultimax 100",
    price: "80",
    description: "The Mark 3 variant is currently used in the Singapore Armed Forces primarily as a support arm, known as the SAW (Squad Automatic Weapon). Famous for its extremely low recoil.",
    images: [
      "/img/vegas-guns/Ultimax-100-Machine-Gun.jpg",
      "/img/vegas-guns/Ultimax-100-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Singapore, Modern Tactical, Battle Tested",
    origin: "Singapore",
    caliber: "5.56x45mm NATO",
    likes: 112
  },
  {
    id: "vickers_mk2",
    title: "Vickers Mk II",
    price: "80",
    description: "The Vickers machine gun is a water-cooled .303 British machine gun produced by Vickers Limited. Legendary for its reliability in WWI trenches.",
    images: [
      "/img/vegas-guns/Vickers-Mk-II-Machine-Gun.jpg",
      "/img/vegas-guns/Vickers-Mk-II-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Great Britain, Belt-Fed, WWI, WWII, Battle Tested, Collector's Item",
    origin: "Great Britain",
    caliber: ".303 British",
    likes: 156
  },
  {
    id: "maxim_m1910",
    title: "Maxim M1910",
    price: "80",
    description: "Blast rounds with the M1910, a heavy machine gun used by the Imperial Russian Army during World War I! Mounted on its distinctive wheeled carriage.",
    images: [
      "/img/vegas-guns/Maxim-M1910-Machine-Gun.jpg",
      "/img/vegas-guns/Maxim-M1910-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Russia, Belt-Fed, WWI, WWII, Eastern Bloc, Battle Tested, Collector's Item",
    origin: "Russia",
    caliber: "7.62x54mmR",
    likes: 145
  },
  {
    id: "dpm",
    title: "DPM",
    price: "80",
    description: "The DPM is a 7.62mm general-purpose machine gun designed in the Soviet Union and put into service in 1928. Features the distinctive pan magazine.",
    images: [
      "/img/vegas-guns/DPM-Machine-Gun.jpg",
      "/img/vegas-guns/DPM-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Russia, WWII, Eastern Bloc, Battle Tested, Video Game Famous",
    origin: "Russia",
    caliber: "7.62x54mmR",
    likes: 123
  },
  {
    id: "bren_mk2",
    title: "Bren Mk2",
    price: "80",
    description: "The BREN Machine Gun was a series of machine guns adopted by Britain in the 1930s and used in various roles until 1991. One of the most reliable LMGs ever made.",
    images: [
      "/img/vegas-guns/Bren-Mk2-Machine-Gun-e1531158633248.jpg",
      "/img/vegas-guns/Bren-Mk2-Machine-Gun-e1531158633248 (1).jpg"
    ],
    category: "Machine Guns, Great Britain, WWII, Battle Tested, Video Game Famous, Collector's Item",
    origin: "Great Britain",
    caliber: ".303 British",
    likes: 178
  },
  {
    id: "breda_m37",
    title: "Breda Modello M-37",
    price: "80",
    description: "The Breda Modello M-37 Machine Gun was used by the Italian Royal Army from 1937 until 1943. A rare piece of WWII Italian military hardware.",
    images: [
      "/img/vegas-guns/Breda-Modello-M-37-Machine-Gun.jpg",
      "/img/vegas-guns/Breda-Modello-M-37-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Italy, WWII, Battle Tested, Collector's Item",
    origin: "Italy",
    caliber: "8x59mm Breda",
    likes: 67
  },
  {
    id: "sg43",
    title: "SG-43",
    price: "80",
    description: "The Goryunov SG-43 was introduced during WWII, intended to replace the M1910 Russian Maxim as the standard medium machine gun.",
    images: [
      "/img/vegas-guns/SG-43-Machine-Gun.jpg",
      "/img/vegas-guns/SG-43-Machine-Gun (1).jpg"
    ],
    category: "Machine Guns, Russia, Belt-Fed, WWII, Eastern Bloc, Battle Tested, Collector's Item",
    origin: "Russia",
    caliber: "7.62x54mmR",
    likes: 98
  },
  {
    id: "rpk",
    title: "RPK",
    price: "60",
    description: "It's the squad automatic weapon RPK! Based on the AK platform, this light machine gun provides sustained fire capability at the squad level.",
    images: [
      "/img/vegas-guns/ZastavaM72.jpg",
      "/img/vegas-guns/ZastavaM72 (1).jpg",
      "/img/vegas-guns/ZastavaM72 (2).jpg"
    ],
    category: "Machine Guns, Russia, Eastern Bloc, Cold War, Battle Tested, Video Game Famous",
    origin: "Russia",
    caliber: "7.62x39mm",
    likes: 134
  },
  {
    id: "hcar",
    title: "Heavy Counter Assault Rifle (HCAR)",
    price: "70",
    description: "The HCAR is a modernized version of the M1918A2 BAR and used in the videogame Battlefield. Bringing the legendary BAR into the 21st century.",
    images: [
      "/img/vegas-guns/HCAR.jpg",
      "/img/vegas-guns/HCAR (1).jpg",
      "/img/vegas-guns/HCAR (2).jpg"
    ],
    category: "Machine Guns, United States, Modern Tactical, Video Game Famous",
    origin: "United States",
    caliber: ".30-06 Springfield",
    likes: 89
  },
  {
    id: "bar",
    title: "M1918A2 Browning Automatic Rifle",
    price: "80",
    description: "Known as the 'BAR', this iconic American weapon provided squad-level automatic fire from WWI through Vietnam.",
    images: [
      "/img/vegas-guns/M1918A2-Browning-Automatic-Rifle-e1530224223901.jpg",
      "/img/vegas-guns/M1918A2-Browning-Automatic-Rifle-e1530224223901 (1).jpg",
      "/img/vegas-guns/M1918A2-Browning-Automatic-Rifle-e1530224223901 (2).jpg"
    ],
    category: "Machine Guns, United States, WWII, Korean War, Battle Tested, Collector's Item, Movie Famous, Video Game Famous",
    origin: "United States",
    caliber: ".30-06 Springfield",
    likes: 156
  },

  // ============================================
  // PISTOLS
  // ============================================
  {
    id: "daewoo_k5",
    title: "Daewoo K5",
    price: "50",
    description: "Add the South Korean K5 Pistol to your cart today! The standard service pistol of the Republic of Korea Armed Forces.",
    images: [
      "/img/vegas-guns/Daewoo-K5-600px.jpg",
      "/img/vegas-guns/Daewoo-K5-600px (1).jpg",
      "/img/vegas-guns/Daewoo-K5-600px (2).jpg"
    ],
    category: "Pistols, South Korea, Modern Tactical",
    origin: "South Korea",
    caliber: "9x19mm Parabellum",
    likes: 56
  },
  {
    id: "hk_p30l",
    title: "HK P30L",
    price: "50",
    description: "This is the type of pistol used by Keanu Reeves in the movie John Wick. A modern striker-fired pistol with exceptional ergonomics.",
    images: [
      "/img/vegas-guns/HK-P30L-Pistol.jpg",
      "/img/vegas-guns/HK-P30L-Pistol (1).jpg",
      "/img/vegas-guns/HK-P30L-Pistol (2).jpg"
    ],
    category: "Pistols, Germany, Modern Tactical, Movie Famous",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 189
  },
  {
    id: "hk_usp45_tactical",
    title: "HK USP-45 Tactical",
    price: "50",
    description: "Quick fire with the HK USP-45 Tactical Pistol from Battlefield Vegas! Features a threaded barrel for suppressor use.",
    images: [
      "/img/vegas-guns/HK-USP-45-Tactical-Pistol.jpg",
      "/img/vegas-guns/HK-USP-45-Tactical-Pistol (1).jpg",
      "/img/vegas-guns/HK-USP-45-Tactical-Pistol (2).jpg"
    ],
    category: "Pistols, Germany, Modern Tactical, Movie Famous, Video Game Famous",
    origin: "Germany",
    caliber: ".45 ACP",
    likes: 145
  },
  {
    id: "sw500",
    title: "Smith & Wesson 500",
    price: "95",
    description: "Check out the Smith & Wesson 500 Pistol from Battlefield Vegas! The most powerful production revolver in the world.",
    images: [
      "/img/vegas-guns/Smith-Wesson-500-Pistol.jpg",
      "/img/vegas-guns/Smith-Wesson-500-Pistol (1).jpg",
      "/img/vegas-guns/Smith-Wesson-500-Pistol (2).jpg"
    ],
    category: "Pistols, United States, Advanced, Movie Famous",
    origin: "United States",
    caliber: ".500 S&W Magnum",
    likes: 234
  },
  {
    id: "fn_fiveseven",
    title: "FN Five-Seven",
    price: "95",
    description: "Blast away with the FN Five-Seven Pistol at Battlefield Vegas! Fires the same armor-piercing round as the P90.",
    images: [
      "/img/vegas-guns/FN-Five-Seven-Pistol.jpg",
      "/img/vegas-guns/FN-Five-Seven-Pistol (1).jpg",
      "/img/vegas-guns/FN-Five-Seven-Pistol (2).jpg"
    ],
    category: "Pistols, Belgium, Modern Tactical, Video Game Famous",
    origin: "Belgium",
    caliber: "5.7x28mm",
    likes: 167
  },
  {
    id: "fn_fnp45",
    title: "FN FNP-45",
    price: "50",
    description: "Grab this modern 45mm pistol and lock your sights in! A tactical pistol designed for military and law enforcement use.",
    images: [
      "/img/vegas-guns/FN-FNP-45-Pistol.jpg",
      "/img/vegas-guns/FN-FNP-45-Pistol (1).jpg",
      "/img/vegas-guns/FN-FNP-45-Pistol (2).jpg"
    ],
    category: "Pistols, United States, Modern Tactical",
    origin: "United States",
    caliber: ".45 ACP",
    likes: 98
  },
  {
    id: "glock18",
    title: "Glock 18 Full-Auto",
    price: "55",
    description: "This Glock 18 Full-Auto Pistol will be sure to put a smile on your face! One of the few select-fire pistols ever made.",
    images: [
      "/img/vegas-guns/Glock-18-Full-Auto-Pistol.jpg",
      "/img/vegas-guns/Glock-18-Full-Auto-Pistol (1).jpg",
      "/img/vegas-guns/Glock-18-Full-Auto-Pistol (2).jpg"
    ],
    category: "Pistols, Austria, Modern Tactical, Movie Famous, Video Game Famous, Top Rated",
    origin: "Austria",
    caliber: "9x19mm Parabellum",
    likes: 278
  },
  {
    id: "sig_p226",
    title: "SIG P226",
    price: "50",
    description: "Reserve the SIG P226 Pistol from Battlefield Vegas today! The legendary service pistol of Navy SEALs and numerous military units worldwide.",
    images: [
      "/img/vegas-guns/SIG-P226-Pistol.jpg",
      "/img/vegas-guns/SIG-P226-Pistol (1).jpg",
      "/img/vegas-guns/SIG-P226-Pistol (2).jpg"
    ],
    category: "Pistols, Germany, NATO Standard, Modern Tactical, Battle Tested, Movie Famous",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 178
  },
  {
    id: "desert_eagle",
    title: "Desert Eagle .50 AE",
    price: "95",
    description: "Fire this notable handgun known around the world. The Desert Eagle's massive size and power have made it an icon of action movies.",
    images: [
      "/img/vegas-guns/Desert-Eagle--50-AE-Pistol.jpg",
      "/img/vegas-guns/Desert-Eagle--50-AE-Pistol (1).jpg",
      "/img/vegas-guns/Desert-Eagle--50-AE-Pistol (2).jpg"
    ],
    category: "Pistols, Israel, Advanced, Movie Famous, Video Game Famous, Top Rated",
    origin: "Israel",
    caliber: ".50 AE",
    likes: 312
  },
  {
    id: "beretta_92fs",
    title: "Beretta 92FS",
    price: "50",
    description: "This is a wonderful performing pistol to get your hands on! The US military's service pistol from 1985 to 2017.",
    images: [
      "/img/vegas-guns/Beretta-92FS-Pistol1.jpg",
      "/img/vegas-guns/Beretta-92FS-Pistol1 (1).jpg",
      "/img/vegas-guns/Beretta-92FS-Pistol1 (2).jpg"
    ],
    category: "Pistols, Italy, NATO Standard, Battle Tested, Movie Famous, Beginner Friendly",
    origin: "Italy",
    caliber: "9x19mm Parabellum",
    likes: 156
  },
  {
    id: "glock17",
    title: "Glock 17",
    price: "50",
    description: "Add the Glock 17 Pistol to your cart today! The pistol that revolutionized the firearms industry with its polymer frame.",
    images: [
      "/img/vegas-guns/Glock-17-Pistol.jpg",
      "/img/vegas-guns/Glock-17-Pistol (1).jpg"
    ],
    category: "Pistols, Austria, NATO Standard, Modern Tactical, Battle Tested, Movie Famous, Beginner Friendly",
    origin: "Austria",
    caliber: "9x19mm Parabellum",
    likes: 198
  },
  {
    id: "mauser_c96",
    title: "Mauser C-96",
    price: "29",
    description: "The Mauser C-96 Pistol is available to shoot at Battlefield Vegas! This distinctive 'Broomhandle' pistol saw service from 1896 through WWII.",
    images: [
      "/img/vegas-guns/Mauser-C-96-22-Pistol.jpg",
      "/img/vegas-guns/Mauser-C-96-22-Pistol (1).jpg"
    ],
    category: "Pistols, Germany, WWI, WWII, Collector's Item, Movie Famous",
    origin: "Germany",
    caliber: "7.63x25mm Mauser",
    likes: 145
  },
  {
    id: "sw_m1917",
    title: "S&W M-1917 Revolver",
    price: "25",
    description: "Used by US military forces from World War I up through World War II. A robust .45 ACP revolver.",
    images: [
      "/img/vegas-guns/SW-M-1917-Pistol.jpg",
      "/img/vegas-guns/SW-M-1917-Pistol (1).jpg"
    ],
    category: "Pistols, United States, WWI, WWII, Battle Tested, Collector's Item, Beginner Friendly",
    origin: "United States",
    caliber: ".45 ACP",
    likes: 89
  },
  {
    id: "makarov",
    title: "Makarov",
    price: "50",
    description: "Take aim with the Makarov Pistol at Battlefield Vegas! The standard Soviet military sidearm throughout the Cold War.",
    images: [
      "/img/vegas-guns/Makarov-Pistol.jpg",
      "/img/vegas-guns/Makarov-Pistol (1).jpg"
    ],
    category: "Pistols, Russia, Cold War, Eastern Bloc, Battle Tested",
    origin: "Russia",
    caliber: "9x18mm Makarov",
    likes: 112
  },
  {
    id: "tokarev",
    title: "Tokarev",
    price: "50",
    description: "You won't regret adding the Tokarev Pistol to your cart! The Soviet service pistol through WWII and Korea.",
    images: [
      "/img/vegas-guns/Tokarev-Pistol.jpg",
      "/img/vegas-guns/Tokarev-Pistol (1).jpg"
    ],
    category: "Pistols, Russia, WWII, Eastern Bloc, Battle Tested, Collector's Item",
    origin: "Russia",
    caliber: "7.62x25mm Tokarev",
    likes: 98
  },
  {
    id: "walther_p38",
    title: "Walther P-38",
    price: "50",
    description: "The Walther P-38 Pistol is ready for you at Battlefield Vegas! The first locked-breech pistol to use a double-action trigger.",
    images: [
      "/img/vegas-guns/Walther-P-38-Pistol.jpg",
      "/img/vegas-guns/Walther-P-38-Pistol (1).jpg"
    ],
    category: "Pistols, Germany, WWII, Battle Tested, Collector's Item, Movie Famous",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 134
  },
  {
    id: "luger_p08",
    title: "Luger P-08",
    price: "50",
    description: "The Luger P-08 Pistol is a great choice here at Battlefield Vegas! One of the most iconic and recognizable pistols ever made.",
    images: [
      "/img/vegas-guns/Luger-P-08-Pistol.jpg",
      "/img/vegas-guns/Luger-P-08-Pistol (1).jpg"
    ],
    category: "Pistols, Germany, WWI, WWII, Collector's Item, Movie Famous, Top Rated",
    origin: "Germany",
    caliber: "9x19mm Parabellum",
    likes: 234
  },
  {
    id: "colt_1911",
    title: "Colt 1911",
    price: "50",
    description: "Fire the Colt 1911, a standard issued firearm in the military. John Browning's masterpiece served the US military for over 70 years.",
    images: [
      "/img/vegas-guns/Colt1911.jpg",
      "/img/vegas-guns/Colt1911 (1).jpg"
    ],
    category: "Pistols, United States, WWI, WWII, Korean War, Vietnam, Battle Tested, Movie Famous, Collector's Item, Beginner Friendly, Top Rated",
    origin: "United States",
    caliber: ".45 ACP",
    likes: 312
  },
  {
    id: "colt_38_special",
    title: "Colt .38 Special Revolver",
    price: "25",
    description: "Check out this medium frame, double action revolver from Battlefield Vegas! A classic American police revolver.",
    images: [
      "/img/vegas-guns/Colt--38-Special-Revolver-e1531243645496.jpg",
      "/img/vegas-guns/Colt--38-Special-Revolver-e1531243645496 (1).jpg"
    ],
    category: "Pistols, United States, Cold War, Beginner Friendly",
    origin: "United States",
    caliber: ".38 Special",
    likes: 78
  },

  // ============================================
  // SNIPER RIFLES
  // ============================================
  {
    id: "barrett_m107a1",
    title: "Barrett M107A1 .50 Caliber",
    price: "35",
    description: "Take aim with this long range fifty caliber Barrett sniper rifle! The M107A1 is used by military forces worldwide for anti-materiel and extreme long-range engagements.",
    images: [
      "/img/vegas-guns/Barett50.jpg",
      "/img/vegas-guns/Barett50 (1).jpg",
      "/img/vegas-guns/Barett50 (2).jpg"
    ],
    category: "Sniper Rifles, United States, Modern Tactical, Battle Tested, Movie Famous, Video Game Famous, Top Rated",
    origin: "United States",
    caliber: ".50 BMG",
    likes: 389
  },
  {
    id: "dragunov_svd",
    title: "Dragunov SVD",
    price: "35",
    description: "Take on one of our favorites, the Dragunov SVD Sniper Rifle! The Soviet Union's legendary designated marksman rifle, still in service worldwide.",
    images: [
      "/img/vegas-guns/Dragunov-SVD-Sniper-Rifles.jpg",
      "/img/vegas-guns/Dragunov-SVD-Sniper-Rifles (1).jpg",
      "/img/vegas-guns/Dragunov-SVD-Sniper-Rifles (2).jpg"
    ],
    category: "Sniper Rifles, Russia, Cold War, Eastern Bloc, Battle Tested, Movie Famous, Video Game Famous, Top Rated",
    origin: "Russia",
    caliber: "7.62x54mmR",
    likes: 278
  },
  {
    id: "scar_h_sniper",
    title: "FN SCAR-H Sniper",
    price: "35",
    description: "Take aim with the FN SCAR-H Sniper Rifle at Battlefield Vegas! Configured for precision shooting with enhanced optics.",
    images: [
      "/img/vegas-guns/FN-SCAR-H-Sniper-Rifle.jpg",
      "/img/vegas-guns/FN-SCAR-H-Sniper-Rifle (1).jpg",
      "/img/vegas-guns/FN-SCAR-H-Sniper-Rifle (2).jpg"
    ],
    category: "Sniper Rifles, Belgium, NATO Standard, Modern Tactical, Battle Tested, Video Game Famous",
    origin: "Belgium",
    caliber: "7.62x51mm NATO",
    likes: 167
  },
  {
    id: "remington_700",
    title: "Remington 700",
    price: "35",
    description: "Check out the Remington 700 Sniper Rifle from Battlefield Vegas! The basis for the US military M24 and M40 sniper systems.",
    images: [
      "/img/vegas-guns/Remington-700-Sniper-Rifle.jpg",
      "/img/vegas-guns/Remington-700-Sniper-Rifle (1).jpg",
      "/img/vegas-guns/Remington-700-Sniper-Rifle (2).jpg"
    ],
    category: "Sniper Rifles, United States, Battle Tested, Movie Famous, Video Game Famous",
    origin: "United States",
    caliber: "7.62x51mm NATO",
    likes: 198
  },
  {
    id: "hk_sr9",
    title: "H&K SR9",
    price: "35",
    description: "Experience HK's extreme precision and accuracy in this SR9 sniper rifle. Based on the proven G3 platform.",
    images: [
      "/img/vegas-guns/HK-SR9-Rifle-e1530224141898.jpg",
      "/img/vegas-guns/HK-SR9-Rifle-e1530224141898 (1).jpg",
      "/img/vegas-guns/HK-SR9-Rifle-e1530224141898 (2).jpg"
    ],
    category: "Sniper Rifles, Germany, NATO Standard, Cold War",
    origin: "Germany",
    caliber: "7.62x51mm NATO",
    likes: 89
  },
  {
    id: "ar15_sniper",
    title: "AR15 Sniper",
    price: "35",
    description: "Precision shooting in the easiest-to-handle package. A purpose-built AR-15 configured for long-range accuracy.",
    images: [
      "/img/vegas-guns/AR15SNIPER.jpg",
      "/img/vegas-guns/AR15SNIPER (1).jpg",
      "/img/vegas-guns/AR15SNIPER (2).jpg"
    ],
    category: "Sniper Rifles, United States, Modern Tactical, Beginner Friendly",
    origin: "United States",
    caliber: "5.56x45mm NATO",
    likes: 112
  },
  {
    id: "m1903a4_springfield",
    title: "M-1903A4 Springfield Sniper",
    price: "35",
    description: "Shoot the army famous M-1903A4 Springfield Sniper Rifle at Battlefield Vegas! The standard US sniper rifle of WWII.",
    images: [
      "/img/vegas-guns/M-1903A4-Springfield-Sniper-Rifle.jpg",
      "/img/vegas-guns/M-1903A4-Springfield-Sniper-Rifle (1).jpg",
      "/img/vegas-guns/M-1903A4-Springfield-Sniper-Rifle (2).jpg"
    ],
    category: "Sniper Rifles, United States, WWII, Battle Tested, Collector's Item, Movie Famous",
    origin: "United States",
    caliber: ".30-06 Springfield",
    likes: 156
  },
  {
    id: "mauser_98k_sniper",
    title: "Mauser 98K Sniper",
    price: "35",
    description: "This rifle still has the military markings and stampings from World War II Nazi Germany. Configured with period-correct optics.",
    images: [
      "/img/vegas-guns/Mauser-98K-Sniper-Rifle.jpg",
      "/img/vegas-guns/Mauser-98K-Sniper-Rifle (1).jpg",
      "/img/vegas-guns/Mauser-98K-Sniper-Rifle (2).jpg"
    ],
    category: "Sniper Rifles, Germany, WWII, Battle Tested, Collector's Item, Video Game Famous",
    origin: "Germany",
    caliber: "7.92x57mm Mauser",
    likes: 178
  },
  {
    id: "mosin_nagant_pu",
    title: "Mosin-Nagant PU Sniper",
    price: "35",
    description: "Blast some rounds with the Mosin-Nagant PU Sniper Rifle at Battlefield Vegas! The legendary Soviet sniper rifle of WWII.",
    images: [
      "/img/vegas-guns/Mosin-Nagant-PU-Sniper-Rifle.jpg",
      "/img/vegas-guns/Mosin-Nagant-PU-Sniper-Rifle (1).jpg",
      "/img/vegas-guns/Mosin-Nagant-PU-Sniper-Rifle (2).jpg"
    ],
    category: "Sniper Rifles, Russia, WWII, Eastern Bloc, Battle Tested, Movie Famous, Video Game Famous, Collector's Item",
    origin: "Russia",
    caliber: "7.62x54mmR",
    likes: 198
  },

  // ============================================
  // SHOTGUNS
  // ============================================
  {
    id: "spas12",
    title: "SPAS-12",
    price: "35",
    description: "Take on the range with the SPAS-12 Shotgun! This iconic Italian combat shotgun can switch between pump and semi-auto operation. Famous from Jurassic Park and countless video games.",
    images: [
      "/img/vegas-guns/SPAS-shotgun-for-website.jpg",
      "/img/vegas-guns/SPAS-shotgun-for-website (1).jpg"
    ],
    category: "Shotguns, Italy, Modern Tactical, Movie Famous, Video Game Famous, Top Rated",
    origin: "Italy",
    caliber: "12 Gauge",
    likes: 234
  },
  {
    id: "vepr12",
    title: "VEPR-12 Automatic",
    price: "35",
    description: "This is the ONLY full-auto VEPR-12 in Las Vegas. Based on the RPK platform, this Russian shotgun delivers devastating automatic firepower.",
    images: [
      "/img/vegas-guns/VEPR-12-Automatic-Shotgun-.jpg",
      "/img/vegas-guns/VEPR-12-Automatic-Shotgun- (1).jpg",
      "/img/vegas-guns/VEPR-12-Automatic-Shotgun- (2).jpg"
    ],
    category: "Shotguns, Russia, Modern Tactical, Video Game Famous, Advanced",
    origin: "Russia",
    caliber: "12 Gauge",
    likes: 189
  },
  {
    id: "remington_870",
    title: "Remington 870",
    price: "35",
    description: "Try out the Remington 870 Shotgun at Battlefield Vegas! The best-selling pump-action shotgun in history.",
    images: [
      "/img/vegas-guns/Remington-870-Shotgun.jpg",
      "/img/vegas-guns/Remington-870-Shotgun (1).jpg",
      "/img/vegas-guns/Remington-870-Shotgun (2).jpg"
    ],
    category: "Shotguns, United States, Battle Tested, Movie Famous, Beginner Friendly",
    origin: "United States",
    caliber: "12 Gauge",
    likes: 156
  },
  {
    id: "coach_gun",
    title: "Old Western Coach Shotgun",
    price: "35",
    description: "You have to try this Old Western Coach Shotgun from Battlefield Vegas! A classic side-by-side double barrel for that Wild West experience.",
    images: [
      "/img/vegas-guns/Old-Western-Coach-Shotgun.jpg",
      "/img/vegas-guns/Old-Western-Coach-Shotgun (1).jpg",
      "/img/vegas-guns/Old-Western-Coach-Shotgun (2).jpg"
    ],
    category: "Shotguns, United States, Collector's Item, Movie Famous, Beginner Friendly",
    origin: "United States",
    caliber: "12 Gauge",
    likes: 134
  },
  {
    id: "model37_trench",
    title: "Model 37 Trench Shotgun",
    price: "35",
    description: "Book your shotgun rounds with the Model 37 Trench shotgun! A combat shotgun design that served from WWII through Vietnam.",
    images: [
      "/img/vegas-guns/Model-37-Trench-Shotgun.jpg",
      "/img/vegas-guns/Model-37-Trench-Shotgun (1).jpg",
      "/img/vegas-guns/Model-37-Trench-Shotgun (2).jpg"
    ],
    category: "Shotguns, United States, WWII, Vietnam, Battle Tested, Collector's Item",
    origin: "United States",
    caliber: "12 Gauge",
    likes: 112
  },
  {
    id: "benelli_m4",
    title: "Benelli M4",
    price: "35",
    description: "Take on the range with this tactical shotgun! The Benelli M4 is the US military's combat shotgun of choice.",
    images: [
      "/img/vegas-guns/BINELLIM4.jpg",
      "/img/vegas-guns/BINELLIM4 (1).jpg",
      "/img/vegas-guns/BINELLIM4 (2).jpg"
    ],
    category: "Shotguns, Italy, Modern Tactical, Battle Tested, Video Game Famous",
    origin: "Italy",
    caliber: "12 Gauge",
    likes: 167
  },

  // ============================================
  // GRENADE LAUNCHERS
  // ============================================
  {
    id: "m203",
    title: "M203 Grenade Launcher",
    price: "35",
    description: "Launch projectiles with the M203 Grenade Launcher from Battlefield Vegas! The standard underbarrel grenade launcher for US forces since Vietnam.",
    images: [
      "/img/vegas-guns/M203-Grenade-Launcher.jpg",
      "/img/vegas-guns/M203-Grenade-Launcher (1).jpg",
      "/img/vegas-guns/M203-Grenade-Launcher (2).jpg"
    ],
    category: "Grenade Launchers, United States, Vietnam, Modern Tactical, Battle Tested, Movie Famous, Video Game Famous",
    origin: "United States",
    caliber: "40mm",
    likes: 198
  },
  {
    id: "m79",
    title: "M79 Grenade Launcher",
    price: "35",
    description: "Take aim and launch some grenades with the M79 Grenade Launcher from Battlefield Vegas! The 'Blooper' or 'Thumper' that defined grenade launchers in Vietnam.",
    images: [
      "/img/vegas-guns/M79-Grenade-Launcher.jpg",
      "/img/vegas-guns/M79-Grenade-Launcher (1).jpg",
      "/img/vegas-guns/M79-Grenade-Launcher (2).jpg"
    ],
    category: "Grenade Launchers, United States, Vietnam, Battle Tested, Movie Famous, Video Game Famous, Collector's Item",
    origin: "United States",
    caliber: "40mm",
    likes: 234
  },
  {
    id: "hk320",
    title: "HK 320 Grenade Launcher",
    price: "35",
    description: "Shoot the HK 320 Grenade Launcher at Battlefield Vegas! The latest generation standalone grenade launcher from Heckler & Koch.",
    images: [
      "/img/vegas-guns/HK-320-Grenade-Launcher.jpg",
      "/img/vegas-guns/HK-320-Grenade-Launcher (1).jpg",
      "/img/vegas-guns/HK-320-Grenade-Launcher (2).jpg"
    ],
    category: "Grenade Launchers, Germany, Modern Tactical, Video Game Famous",
    origin: "Germany",
    caliber: "40mm",
    likes: 145
  },

  // // ============================================
  // // PACKAGES
  // // ============================================
  // {
  //   id: "wwii_package",
  //   title: "WWII Combat Package",
  //   price: "299",
  //   description: "Experience the weapons that won World War II! This package includes iconic firearms from both Allied and Axis forces. Includes: M1 Garand, Thompson SMG, MP40, Mauser 98K, and more.",
  //   images: [
  //     "/img/vegas-guns/M1-Garand-Main-Battle-Rifle.jpg",
  //     "/img/vegas-guns/Mauser-98K-Main-Battle-Rifle.jpg",
  //     "/img/vegas-guns/Mosin-Nagant-M9130-Battle-Rifle.jpg"
  //   ],
  //   category: "Packages, WWII Package, WWII, Battle Tested, Movie Famous, Video Game Famous",
  //   origin: "Various",
  //   likes: 345
  // },
  // {
  //   id: "vietnam_package",
  //   title: "Vietnam War Package",
  //   price: "279",
  //   description: "Step into the jungle with weapons from the Vietnam War era! Experience both American and Viet Cong weapons. Includes: M16A1, AK-47, M60, M14, and more.",
  //   images: [
  //     "/img/vegas-guns/M16A1-Assault-Rifle.jpg",
  //     "/img/vegas-guns/AK-47-Assault-Rifle-.jpg",
  //     "/img/vegas-guns/M14-Main-Battle-Rifle.jpg"
  //   ],
  //   category: "Packages, Vietnam Package, Vietnam, Battle Tested, Movie Famous, Video Game Famous",
  //   origin: "Various",
  //   likes: 267
  // },
  // {
  //   id: "modern_warfare_package",
  //   title: "Modern Warfare Package",
  //   price: "349",
  //   description: "Fire today's cutting-edge military hardware! This package features the latest weapons used by special operations forces. Includes: M4, HK416, FN SCAR, and more.",
  //   images: [
  //     "/img/vegas-guns/M4-Assault-Rifle-.jpg",
  //     "/img/vegas-guns/HK-416-Assault-Rifle.jpg",
  //     "/img/vegas-guns/FN-SCAR-H-Assault-Rifle.jpg"
  //   ],
  //   category: "Packages, Modern Warfare Package, Modern Tactical, NATO Standard, Video Game Famous",
  //   origin: "Various",
  //   likes: 412
  // },
  // {
  //   id: "extreme_package",
  //   title: "Extreme Firepower Package",
  //   price: "499",
  //   description: "Go big or go home! Our most powerful and impressive firearms for the ultimate shooting experience. Includes: M2 .50 Cal, Barrett .50 Cal, Minigun, and more.",
  //   images: [
  //     "/img/vegas-guns/M2-Browning-22Ma-Deuce22-Machine-Gun.jpg",
  //     "/img/vegas-guns/Barett50.jpg",
  //     "/img/vegas-guns/MG-42-Machine-Gun.jpg"
  //   ],
  //   category: "Packages, Extreme Package, Advanced, Movie Famous, Top Rated",
  //   origin: "Various",
  //   likes: 523
  // },
];

// Helper function to get items by category
export const getItemsByCategory = (category: string): Gun[] => {
  return items.filter(item =>
    item.category.toLowerCase().includes(category.toLowerCase())
  );
};

// Helper function to get items by origin country
export const getItemsByOrigin = (origin: string): Gun[] => {
  return items.filter(item =>
    item.origin.toLowerCase() === origin.toLowerCase()
  );
};

// Helper function to get items within a price range
export const getItemsByPriceRange = (min: number, max: number): Gun[] => {
  return items.filter(item => {
    const price = parseFloat(item.price);
    return price >= min && price <= max;
  });
};

// Helper function to get top-rated items
export const getTopRatedItems = (limit: number = 10): Gun[] => {
  return [...items]
    .sort((a, b) => b.likes - a.likes)
    .slice(0, limit);
};

// Helper function to search items by title or description
export const searchItems = (query: string): Gun[] => {
  const lowerQuery = query.toLowerCase();
  return items.filter(item =>
    item.title.toLowerCase().includes(lowerQuery) ||
    item.description.toLowerCase().includes(lowerQuery)
  );
};

// Helper function to get items by weapon type
export const getItemsByType = (type: string): Gun[] => {
  const typeMap: { [key: string]: string } = {
    'assault': 'Assault Rifles',
    'battle': 'Battle Rifles',
    'smg': 'Submachine Guns',
    'machinegun': 'Machine Guns',
    'shotgun': 'Shotguns',
    'pistol': 'Pistols',
    'sniper': 'Sniper Rifles',
    'carbine': 'Carbines',
    'grenade': 'Grenade Launchers',
    'package': 'Packages'
  };

  const categoryName = typeMap[type.toLowerCase()] || type;
  return getItemsByCategory(categoryName);
};